/* eslint-disable max-lines */
export default class LNG {
    public static SetLanguage = (Language: string): void => {}
    public static ABOUT = 'About';
    public static ACCESSDENIED = 'Access denied';
    public static ACTIONS = 'Actions';
    public static ACTIVATEPRODUCTFIRSTINSPSITE = ' Please activate [PRODUCT] on your SharePoint site first.';
    public static ACTUALWORKINHR = 'Actual Work in Hrs';
    public static ACTUALWORKINHRS = 'Actual working Hrs.';
    public static ADD = 'Add';
    public static ADDASACCESSPERMISSION = 'You do not have permission to access this SharePoint site. Please contact the site collection Administrator.';
    public static ADDATTACHMENT = 'Add attachment';
    public static ADDATTACHMENTS = 'Include attachments';
    public static ADDCALCULATEDVALUE = 'Add calculated value';
    public static ADDCALENDAR = 'New calendar';
    public static ADDCATEGORY = 'Add Category';
    public static ADDCATEGORYTYPE = 'Add Category Type';
    public static ADDCBFOLDER = 'Add CB Group';
    public static ADDCBGROUPMESSAGE = 'Please press the "Add CB Group" button to select Calendar Browser installation.';
    public static ADDCONDITION = 'Add condition';
    public static ADDEDIT = 'Add/Edit';
    public static ADDEDLIBRARIES = 'Added libraries:';
    public static ADDEMAILFOLDER = 'Add Folder';
    public static ADDEPARTMENT = 'Departments';
    public static ADDING2050 = 'An event will now be added to the calendar at 1 Jan 2050. This event contains all of your personal settings.';
    public static ADDINGNEWCONTENTTYPE = 'Adding content type';
    public static ADDINGNEWFIELD = 'Adding new field';
    public static ADDINGOLDCATEGORYINDB = 'Adding [PRODUCT1] categories to the[PRODUCT2] database';
    public static ADDINGOLDCATEGORYTYPESINDB = 'Adding [PRODUCT1] category types to the [PRODUCT2] database';
    public static ADDINGOLDCUSTOMPROPERTISINDB = 'Adding custom user properties of [PRODUCT1] to the [PRODUCT2] database';
    public static ADDINGVIEW = 'Adding view';
    public static ADDLIST = 'Add List';
    public static ADDMETAINAPPBODY = 'Add tags in the event body';
    public static ADDMINUTES = 'Add minutes';
    public static ADDNEW = 'Add new';
    public static ADDNEWCALENDARSQ = 'Would you like to add a new calendar now?';
    public static ADDONEITEM = 'Please enter at least one [ITEM] in the [ITEMS] list. ';
    public static ADDORDELCUSTOMFIELDINDATABASE = 'You need to have administrator credentials to add or remove custom fields';
    public static ADDPERMISSION = 'You do not have permission to add articles';
    public static ADDPHASE = 'Add phase';
    public static ADDSPLIST = 'Add SharePoint list';
    public static ADDSPTASKLIST = 'Add a new SharePoint list';
    public static ADDSTUDENT = 'Add Student';
    public static ADDSTUDYGROUP = 'Add Study Group';
    public static ADDTICKETBUTTON = 'Add button';
    public static ADDTITLE = 'Add a new template';
    public static ADDTOANOTHER = 'Move time reports to:';
    public static ADDTOFIELD = 'Add to the field %s';
    public static ADDTOKB = 'Add to KB';
    public static ADDTOKBTT = 'Check this box to make this ticket appear in the Knowledge Base';
    public static ADDTOTICKET = 'Add e-mail to ticket ...';
    public static ADDUSER = 'Add User ';
    public static ADDUSERS = 'Add Users';
    public static ADMIMISTRATORPRIVILEGES = 'Administrator privileges';
    public static ADMINISTRATION = 'Administration ';
    public static ADMINISTRATOR = 'Administrator';
    public static ADMINMANUAL = 'Admininstrator Manual';
    public static ADMINSPECIFIEDPERSONSRATE = 'Admin Specified';
    public static ADVANCED = 'Advanced';
    public static AFTERCONVERSION = 'After conversion:';
    public static AGENDA = 'Agenda';
    public static ALL = 'All';
    public static ALLDAY = 'All day';
    public static ALLDETAILS = 'Please enter all details';
    public static ALLEVENTS = 'All Events';
    public static ALLKANBANVALUESNOTFILLEDOUT = 'Please add at least one Incident type, Responsible and Status to use the kanban view.';
    public static ALLOWAUTOOFCALLER = 'Auto-add new caller';
    public static ALLOWREPORTINGOFALLEMPTYFIELDS = 'Allow reporting of not tagged events';
    public static ALLSITES = 'All Sites';
    public static ALLTASKAREFINISHED = 'All task(s) are completed.';
    public static ALLVALUES = 'All values';
    public static ALLVALUESNOTFILLEDOUT = 'All mandatory values are not filled out!';
    public static ALPHANUMERIVVALUEINPUT = 'Please use only letters and numbers. Special signs are not allowed.';
    public static ALREADPHASE = 'A phase with this name already exists. Please use another phase name.';
    public static ALREADPROJECT = 'A project with this name already exists. Please use another project name.';
    public static ALREADRESPONSIBLE = 'A responsible with this name already exists. Please use another responsible name.';
    public static ALSOBOOK = 'Also book';
    public static ALWAYSSEARCH = 'Always show Search';
    public static ALWAYSUSEDEFAULT = 'Always use the default';
    public static AMOUNT = 'Amount';
    public static ANALYSISSERVICES = 'Please give the name of the MS Analysis Services server you wish to connect to';
    public static ANALYZE = 'Analyze';
    public static ANALYZEANDVISUALIZELISTDATA = 'Analyze and visualize list data';
    public static AND = 'And';
    public static ANERRORHASOCCURRED = 'An error has occurred:';
    public static ANOTHERWEEK = 'Would you like to report for another period?';
    public static ANSWER = 'Answer';
    public static ANYFILE = 'Any file';
    public static APPID = 'Event ID';
    public static APPLY = 'Apply';
    public static APPLYTAGS = 'Apply tags';
    public static APPOINTMENT = 'Event';
    public static APPOINTMENTOPENANOTHER = 'The event can not be opened. Either you do not have sufficient permission or an another dialog box is already open.';
    public static APPOINTMENTPERORGANIZER = 'Number of Bookings per Organizer';
    public static APPOINTMENTS = 'Events';
    public static APPOINTMENTSEXPORTEDTODB = 'Events exported to the database =';
    public static APPOINTMENTSREPORTVIEWNAME = 'Events Report';
    public static APPOINTNOTE = 'Event note';
    public static APPROPRIATION = 'Appropriation';
    public static APPSCREATED = 'New events created:';
    public static APR = 'Apr';
    public static APRIL = 'April';
    public static ARCHIVE = 'Archive';
    public static ARCHIVEANDDELETE = 'Delete events from the calendars and save information in the database only';
    public static ARCHIVECLOSED = 'Archive closed';
    public static ARCHIVEDSUCCESSFULLY = 'Items archived successfully.';
    public static ARCHIVETO = 'Archive To';
    public static ARCHIVETOOLEXPORTSFORM = 'The Archive tool exports events from the Calendar Browser calendars to a database.';
    public static ARCHIVINGCOMPLETED = 'Archiving successfully completed.';
    public static ARCHIVINGITEMCOUNT = 'Archiving item [C] of [T]';
    public static AREA = 'Area';
    public static ARTICLE = 'Article';
    public static ARTICLECATEGORY = 'Article Category';
    public static ARTICLEID = 'Article ID';
    public static ARTICLESUBJECT = '[PRODUCT] article [SUBJECT]';
    public static ASK = 'Ask';
    public static ASKBEFOREATTACHTOSP = 'Ask before adding attachment to SharePoint';
    public static ASSIGNDEFAULTMINUTESTOTICKET = 'Assign default minutes to a closing ticket if the ^Minutes worked^ field is empty';
    public static ASSIGNTO = 'Responsible';
    public static ATLEASTONECALENDAR = 'You need to select at least one calendar to use this feature.';
    public static ATLEASTONEFIELD = 'Please select at least one field.';
    public static ATLEASTONETAG = 'Please enter at least one tag.';
    public static ATLEASTONETAGVALUE = 'Please set at least one [TAG] value.';
    public static ATLEASTONEVIEW = 'Please select at least one view for the Overview';
    public static ATLEASTPROJECTANDPHASE = 'Please add at least one project and one phase.';
    public static ATLEASTPROJECTRESPONSIBLEPHASE = 'Please add at least one project, responsible and phase.';
    public static ATTACH = 'Attached file';
    public static ATTACHAUDIO = 'Attach an audio file to this text if you want students to be able to listen to it. Check the "Sound only" box if you want the text to be hidden when the sound is played .';
    public static ATTACHAUDIOFIRST = 'Please attach an audio file first.';
    public static ATTACHEDDOCTEACHERASSTUDENT = 'This exercise has at least one attached document. To test the attachment task, the teacher needs to be added as a student.';
    public static ATTACHMENT = 'Attachment';
    public static ATTACHMENTINDBONCLOSED = 'Save e-mails and attachments in the database when a ticket is closed.';
    public static ATTACHMENTTOSPCONFIRMATIONMESSAGE = 'Are you sure you want to add this file to SharePoint instead of sending it as an e-mail attachment?<BR>If you answer Yes, there will be a link to the file in the e-mail.';
    public static ATTENDEES = 'Attendees';
    public static AUG = 'Aug';
    public static AUGUST = 'August';
    public static AUTHENTICATE = 'Authenticate';
    public static AUTHENTICATION = 'Authentication';
    public static AUTO = 'Auto';
    public static AUTOADDPROPERTIES = 'Allow Auto-Add of tag values';
    public static AUTOBOOKING = 'Auto-Booking';
    public static AUTOBOOKINGFAILD = 'Auto booking failed, because no double-bookings are allowed in this calendar.';
    public static AUTODOWNLOAD = 'Auto-download';
    public static AUTODOWNLOADHELP = 'Download PDFs to your device immediately.';
    public static AUTOMATICNOTIFICATIONEMAIL = 'E-mail to admin. spec. list when ticket is created';
    public static AUTOMATICNOTIFICATIONSETTINGS = 'Automatic Notification Settings';
    public static AUTOSAVEHELP = 'Save PDFs directly to a SharePoint library.';
    public static AUTOSAVETOLIBRARY = 'Auto-save to library';
    public static AVAILABLELIBRARIES = 'Available libraries:';
    public static AVERAGE = 'Average';
    public static AVGOFHOURSOPEN = 'Average of Hours Open';
    public static BACK = 'Back';
    public static BACKGROUND = 'Background';
    public static BAR = 'Bar';
    public static BATCHOPTIONSSUBTITLE = 'Choose your output and delivery options below.';
    public static BEFOREAMONTHYEAR = 'Before a Month/Year';
    public static BEFORETHISDATE = 'Before this date';
    public static BEFOREYEARMONTH = 'Before Year/Month';
    public static BEGINSWITH = 'begins with';
    public static BELOW = 'Below';
    public static BETWEEN = 'Between';
    public static BODY = 'Body';
    public static BOLD = 'Bold';
    public static BOOK = 'Book';
    public static BOOKEDBY = 'Booked by';
    public static BOOKEDHORSPERRESOURCE = 'Booked Hours per Resource';
    public static BOOKEDHRS = 'Booked Hours';
    public static BOOKING = 'Booking';
    public static BOOKINGINFO = 'Booking info';
    public static BOOKSUPPLIES = 'Book Supplies';
    public static BOTH = 'Both';
    public static BOTTOM = 'Bottom';
    public static BROWSE = 'Browse';
    public static BROWSECBFOLDER = 'Go to CB...';
    public static BROWSECBFOLDERTT = 'Go to the Calendar Browser folder';
    public static BROWSECBNWFOLDER = 'Browse to the CB network folder';
    public static BROWSECBNWFOLDERTT = 'The CB Client Tool cannot find the network folder. Browse to select it.';
    public static BROWSEEXISTINGCALENDAR = 'Browse to an existing calendar';
    public static BROWSERDNOTSUPPORTSPEECHRATE = 'Your browser does not support changes of the reading rate, so you will not be able to change that.';
    public static BROWSERUNSUPPORTEDAUDIOFILE = 'You cannot sync sound with the text, because yur browser cannot play MP3, OGG or WAV files.';
    public static BUBBLE = 'Bubble';
    public static BUDGET = 'Budget';
    public static BUILTINASSINGTO = 'Use the default Assign To field';
    public static BUILTINPHASES = 'Use the default Status field';
    public static BULLETS = 'Bullets';
    public static BUSY = 'Busy';
    public static BUTTONADDED = 'HelpDesk Ticket button successfully added!';
    public static BUY = 'Buy Now';
    public static BY = 'By';
    public static CACHECLEARED = 'The [PRODUCT] cache memory in your web browser has been cleared. Please try again.';
    public static CALCULATEERROR = 'Error in calculating the Pivot Table results.';
    public static CALCULATEINDIVIDUALVALUES = 'Calculate individual values';
    public static CALENDAR = 'Calendar';
    public static CALENDAREXIST = '[CALENDARNAME] already exists. Please use another calendar name.';
    public static CALENDARNAMEEXISTS = 'A calendar with the name [CALENDARNAME] already exists.';
    public static CALENDARS = 'Calendars';
    public static CALENDARSFOUND = 'Calendars found';
    public static CALENDERAPPPERPROJECT = 'Events per Project';
    public static CALENDERAPPPERSUBJECT = 'Events per Subject';
    public static CALENDERAPPPERWEEKDAY = 'Events per Day of the week';
    public static CALENDERAPPPERYEAR = 'Events per Year';
    public static CALENDERNAMECANNOTBEEMPTY = 'Calendar Name cannot be empty. Please enter a calendar name.';
    public static CALLER = 'Caller';
    public static CALLERCATEGORIES = 'Caller Categories';
    public static CALLERCATEGORY = 'Caller Category';
    public static CALLERCATEGORYAVGHRSOPEN = 'Average ticket time per Caller Category';
    public static CALLERCATEGORYHOURS = 'Sum of hours spent on each Caller Category';
    public static CALLERCATEGORYNUMBER = 'Number of tickets per Caller Category';
    public static CALLERCATEGORYRATE = 'Cost per Caller Category';
    public static CALLERCOMMENT = 'Caller comment';
    public static CALLEREMAIL = 'Caller E-mail';
    public static CALLEREMAILBODY1 = 'We have received your e-mail with the subject [SUBJECT] regarding';
    public static CALLEREMAILBODY2 = 'A ticket with the ID [TICKETID] has been created';
    public static CALLERNAME = 'Caller Name';
    public static CALLERPHONE = 'Caller phone';
    public static CALLERS = 'Callers';
    public static CALLERSINCATEGORY = 'Callers within the selected category';
    public static CALLTO = 'Call to';
    public static CANCEL = 'Cancel';
    public static CANCELLED = 'Cancelled';
    public static CANCELPROCESSING = 'Press ^Cancel^ to stop processing.';
    public static CANNOTBLANK = 'cannot have a blank value.';
    public static CANNOTOPENOLDVERSION = 'The Excel reports can only be opened in Excel 2007 and higher';
    public static CAPTION = 'Caption';
    public static CATEGORIES = 'Categories';
    public static CATEGORY = 'Category';
    public static CATEGORYANDTYPE = 'Category and type';
    public static CBADDFINISHED = 'New [PRODUCT] installation added successfully. ';
    public static CBCLIENTTOOLS = 'You need to install the Calendar Browser  Client Tools to use this functionality!';
    public static CBEXCALCAT1 = 'Level 2';
    public static CBEXCALCAT2 = 'Level 4';
    public static CBEXCALCAT3 = 'Ground floor';
    public static CBEXCALNAME1 = 'Cafeteria Level 2';
    public static CBEXCALNAME2 = 'Cafeteria Level 4';
    public static CBEXCALNAME3 = 'Gymnasium';
    public static CBEXCALNAME4 = 'Projection Room';
    public static CBEXCALNAME5 = 'Conf Room A';
    public static CBEXCALNAME6 = 'Reception Area';
    public static CBEXCALNAME7 = 'Conf Room B';
    public static CBEXCALNAME8 = 'Terrace';
    public static CBEXCALNAME9 = 'Lawn';
    public static CBEXCAT1 = 'Investor Interaction';
    public static CBEXCAT10 = 'Supply Chain Management';
    public static CBEXCAT11 = 'Employee^s Families Get-together';
    public static CBEXCAT12 = 'Quarterly Review';
    public static CBEXCAT13 = 'CEO Address';
    public static CBEXCAT2 = 'New Product Design';
    public static CBEXCAT3 = 'Creative Brief Discussion';
    public static CBEXCAT4 = 'Sales Pitch Brainstorming Session';
    public static CBEXCAT5 = 'HR Performance Review';
    public static CBEXCAT6 = 'IT Systems Review';
    public static CBEXCAT7 = 'Empolyee Counselling';
    public static CBEXCAT8 = 'Recreational Outing Discussion';
    public static CBEXCAT9 = 'Diversification Plans Discussion';
    public static CBEXSUBJ1 = 'Meeting';
    public static CBEXSUBJ10 = 'Internal Review Meeting';
    public static CBEXSUBJ2 = 'Project Tasks Delegation';
    public static CBEXSUBJ3 = 'Performance Review';
    public static CBEXSUBJ4 = 'Client Brief';
    public static CBEXSUBJ5 = 'Teleconference';
    public static CBEXSUBJ6 = 'Sales Pitch';
    public static CBEXSUBJ7 = 'Trip to HQ';
    public static CBEXSUBJ8 = 'Call to Laura Callahan';
    public static CBEXSUBJ9 = 'Visit to Retailers';
    public static CBEXSUP1 = 'Coffee';
    public static CBEXSUP10 = 'Cars';
    public static CBEXSUP11 = 'Petty cash';
    public static CBEXSUP12 = 'File Folders';
    public static CBEXSUP13 = 'Card Holders';
    public static CBEXSUP2 = 'Tea';
    public static CBEXSUP3 = 'Water';
    public static CBEXSUP4 = 'Notepads';
    public static CBEXSUP5 = 'Cookies';
    public static CBEXSUP6 = 'Biscuits';
    public static CBEXSUP7 = 'Snacks';
    public static CBEXSUP8 = 'Writing tools';
    public static CBEXSUP9 = 'Projectors';
    public static CBEXTEXT1 = 'Comfortable and casual seating arrangement for 100 people';
    public static CBEXTEXT2 = 'Functional during business hours';
    public static CBEXTEXT3 = 'Ample provision for a variety of food and drinks';
    public static CBEXTEXT4 = 'Seating capacity for 250 people';
    public static CBEXTEXT5 = 'Functional round-the-clock';
    public static CBEXTEXT8 = 'Audio-visual system in place';
    public static CBEXTTEXT10 = 'Requires advance booking by at least 1 day';
    public static CBEXTTEXT11 = 'All necessary projection equipment in place.';
    public static CBEXTTEXT12 = 'Clearance from CEO required before usage';
    public static CBEXTTEXT13 = 'Theatrical-style seating';
    public static CBEXTTEXT14 = 'Audience capacity for up to 200 persons';
    public static CBEXTTEXT15 = 'Requires 2-days prior intimation';
    public static CBEXTTEXT16 = 'Audio-visual setup in place';
    public static CBEXTTEXT17 = 'Doubles up as reading area, what with large number of publications placed there';
    public static CBEXTTEXT18 = 'Limited seating capacity - 25 persons';
    public static CBEXTTEXT19 = 'Rectangular table with seating provision for up to 18 persons';
    public static CBEXTTEXT20 = 'NO additional seating capacity';
    public static CBEXTTEXT21 = 'Catering from cafeteria';
    public static CBEXTTEXT22 = 'Capacity for 50 people standing';
    public static CBEXTTEXT23 = 'Ideal for informal discussion groups';
    public static CBEXTTEXT24 = 'Lush greenery with seating arrangement spread all around';
    public static CBEXTTEXT25 = 'Good for informal interactions between small groups';
    public static CBEXTTEXT26 = 'Dais with podium';
    public static CBEXTTEXT6 = 'Space for up to 100 standing individuals';
    public static CBEXTTEXT7 = 'Good for large informal gathering, called at short notice or for public announcement';
    public static CBEXTTEXT9 = 'Seating Capacity 150';
    public static CBFOLDEREXISTS = 'This [PRODUCT] Group is already added';
    public static CBNETWORKPATHADDED = 'CB network path added';
    public static CBREPORTS = '[PRODUCT] Reports';
    public static CBREPORTSAPP = 'Calendar Browser Events Reports';
    public static CBREPORTSCOST = 'Calendar Browser Costs Reports';
    public static CENTER = 'Center';
    public static CHANGE = 'Change';
    public static CHANGED = 'Changed';
    public static CHANGEDPROPERTIES = 'Changed properties';
    public static CHANGELOG = 'Change log';
    public static CHANGESPUBLISHEDSCCESSFULLY = 'Changes published successfully.';
    public static CHANGESQLAZUREUSER = 'Change SQL Azure user';
    public static CHANGETASKLIST = 'Switch Tasks List';
    public static CHANGINGFORMCOLVISIBILITY = 'Changing form column visibility';
    public static CHAPTER = 'Chapter';
    public static CHAPTERCOLUMNPARTDESCRIPTION = 'Select what part this chapter should belong to.';
    public static CHAPTERCOLUMNSEQUENCEDESCRIPTION = 'Specify the order of this chapter in relation to other chapters.';
    public static CHAPTERS = 'Chapters';
    public static CHARS255 = '255 characters';
    public static CHART = 'Chart';
    public static CHARTS = 'Charts';
    public static CHECKDELETETEMPLATE = 'Are you sure you want to delete the template?';
    public static CHECKINGUSERNAME = 'Checking user name, please wait...';
    public static CHECKLIST = 'Checklist';
    public static CHECKLISTTEMPLATES = 'Checklist templates';
    public static CHECKPERM = 'Check that you have the appropriate permissions!';
    public static CHOOSE = 'Choose';
    public static CHOOSEALTERNATIVES = 'Choose alternatives';
    public static CHOOSECOLOR = 'Choose color';
    public static CHOOSEFILE = 'Select file to attach';
    public static CHOOSEFILTER = 'Choose filter';
    public static CHOOSEFOLDER = 'Choose folder';
    public static CHOOSEFOLDERTOMONITOR = 'Choose folder to monitor. Incoming e-mails will be converted to [PRODUCT] tickets.';
    public static CHOOSEITEMS = 'Choose supplies to order';
    public static CHOOSESPLISTS = 'Choose a SharePoint list';
    public static CHOOSESPLISTSEXP = 'Choose a SharePoint list from the available lists below.';
    public static CHOOSEWHERETOCREATE = 'Choose where to create the new folder.';
    public static CLASSIC = 'Classic';
    public static CLEANUP = 'Clean-Up';
    public static CLEANUPCONFIRMATION = 'Are you sure you want to clean-up [PRODUCT]?';
    public static CLEANUPCONFIRMATIONKTM = 'This will delete all example tasks and reset all settings to default. Are you sure?';
    public static CLEANUPSUCCESSFORUPGRADE = '[PRODUCT] files has been cleaned-up successfully. Please deactivate [PRODUCT] on each site where it is used and in the Solutions gallery before you upload the latest version from kalmstrom.com to upgrade [PRODUCT].';
    public static CLEAR = 'Clear';
    public static CLEARCACHE = 'Clear Cache';
    public static CLEARIMAGE = 'Clear image';
    public static CLEARSEARCH = 'Clear Search';
    public static CLICKHERE = 'click here:';
    public static CLICKME = 'Click me to find out more';
    public static CLICKTOFILTER = 'Click to filter';
    public static CLIENTTOOLS = 'You need to install the %s to use this functionality.';
    public static CLOSE = 'Close';
    public static CLOSED = 'Closed';
    public static CLOSEDTICKETINDB = 'Closed tickets in the database';
    public static CLOSEEDDATE = 'Date Closed';
    public static CLOSEOVERVIEW = 'Calendar Browser will close the Overview to save the settings.';
    public static CLOSETICKET = 'Close ticket';
    public static CLOSETICKETNAG = 'Do you want to close this ticket?';
    public static CLOSETICKETNOTIFY = 'Automatic e-mail to Caller when ticket is closed';
    public static CLOSEWITHOUTSAVING = 'Close without saving?';
    public static COLHEATMAP = 'Heat map Column';
    public static COLLAPSEINITIALLY = 'Collapse initially';
    public static COLLAPSIBLEOUTLINE = 'Collapsible table of contents';
    public static COLOR = 'Color';
    public static COLORASSOCIATION = 'Color association';
    public static COLORCODE = 'Color Code';
    public static COLUMN = 'Column';
    public static COLUMNLINE = 'Column line';
    public static COLUMNS = 'Columns';
    public static COLUMNSPERPHASE = 'Columns per phase';
    public static COLUMNSPERSTATUS = 'Columns per status';
    public static COMMASEPARATEDITEMS = 'Comma and space separated items';
    public static COMMENT = 'Comment';
    public static COMMUNITYGROUP = 'Community Group';
    public static COMPACT = 'Compact ';
    public static COMPANY = 'Company';
    public static COMPANYDEPARTMENT = 'Company/Department';
    public static COMPLETED = 'Completed';
    public static COMPLETEDDATE = 'Completed Date';
    public static COMPLETEDINPERCENT = '% completed';
    public static COMPLETEDTASKSPERPHASE = 'Completed Tasks per Phase';
    public static COMPLETETASKNAME = 'Complete task [TASKNAME]?';
    public static COMPOSESIGNATURE = 'Compose an HTML signature to use in Folder HelpDesk outgoing e-mails.';
    public static COMPUTEERROR = 'An error occurred computing the Pivot Table results.';
    public static CONDITIONALFORMATTING = 'Conditional formatting';
    public static CONFIGURATION = 'Configuration';
    public static CONFIGUREAPPPART = 'This action is not supported in add-in parts. First add the current page URL in the add-in part properties.';
    public static CONFIGURESITES = 'Configure SharePoint lists ...';
    public static CONFIGURESITESTT = 'Add/Remove SharePoint lists';
    public static CONFIRMATION = 'Automatic e-mail to Caller when ticket is created';
    public static CONFLICTEXTRAVALUE = 'This extra field value has been removed. What would you like to do with the time reports which belong to this value?';
    public static CONFLICTVALUE = 'A value which previously was in the list is no longer available.';
    public static CONNECT = 'Connect';
    public static CONNECTIONFAILED = 'Connection failed.';
    public static CONNECTIONSUCCEEDED = 'Connection succeeded!';
    public static CONNECTWITHIMAGE = 'Connect with image';
    public static CONNETCIONPROBLEM = 'Folder HelpDesk has encountered a general network error. Please consult your network admin.';
    public static CONTAINS = 'contains';
    public static CONTROLPANEL = 'Control Panel';
    public static CONVERSIONCOMPLETE = 'Conversion complete';
    public static CONVERSIONFAILED = 'Failed to convert this document.';
    public static CONVERT = 'Convert';
    public static CONVERTALLMAILINFHDSUBFOLDERSTOTICKETBODY = 'Do you want to add all e-mails from the Folder HelpDesk subfolders to the corresponding tickets?';
    public static CONVERTED = 'Converted:';
    public static CONVERTEDFILES = 'Converted files:';
    public static CONVERTFILESTOPDF = 'Convert [COUNT] files to PDF';
    public static CONVERTFULLDAYSTOHOURS = 'Convert all day events into hours';
    public static CONVERTINGFILEOFN = 'Converting file [N] of [TOTAL]...';
    public static CONVERTINGTOPDF = 'Converting your document to PDF...';
    public static COPIEDAPPOINTMENT = 'This is a copy of a meeting created in the calendar: XXX';
    public static COPY = 'Copy';
    public static COPYCURRENTFILTER = 'Copy current filter';
    public static COPYEMAILMSG = 'The destination folder is not correct, Please select a mail or post type folder to copy e-mail. Do you want to try again?';
    public static COPYINGFILE = 'Copying file...';
    public static COPYINGFINISHED = 'Copying finished';
    public static COPYTHEDOCFIRST = 'Please copy the document first.';
    public static COPYTICKET = 'Copy ticket';
    public static COPYTOOTHER = 'Create copy of new events in other calendar';
    public static CORRECTALTERNATIVE = 'Correct alternative';
    public static CORRECTALTERNATIVEHERE = 'Write the correct alternative here.';
    public static CORRECTALTERNATIVES = 'Correct alternatives';
    public static CORRECTALTERNATIVESCOLUMNDESCRIPTION = 'Enter the correct alternatives, one for each row.';
    public static CORRECTANSWERFIRST = 'Please select the correct answer first. ';
    public static CORRECTPHRASE = 'Correct phrase';
    public static CORRPUTSETTINGXML = 'Your [PRODUCT] Settings file has become corrupt, so your settings have been lost and you have to configure [PRODUCT] again. Please inform support@kalmstrom.com if this is a recurring problem.';
    public static COST = 'Cost';
    public static COSTCARRIER = 'Calculate costs by';
    public static COSTCENTER = 'Cost Center';
    public static COSTCENTERMANDATORY = 'Cost Center is mandatory. Please fill out this field.';
    public static COSTOFITEMSPERPERCALENDARAPPOINTMENT = 'Cost of Items per Booking';
    public static COSTOFORDEREDITEMSPERORGANIZER = 'Cost of Supplies per Organizer';
    public static COSTOFRESOURCE = 'Cost of Resources';
    public static COSTOFRESOURCESANDITEMS = 'Cost of Resources + Supplies';
    public static COSTOGITEMSORDERESPERRESOURCE = 'Cost of Supplies per Resource';
    public static COSTRESOURCEPERORGANIZER = 'Cost of Resources per Organizer';
    public static COSTSANDRATES = 'Costs and Rates';
    public static COSTSUPPLIES = 'Cost of supplies';
    public static COULDNOTCONVERT = 'Could not convert';
    public static COUNT = 'Count';
    public static COUNTASFRACTIONOFCOLUMNS = 'Count as Fraction of Columns';
    public static COUNTASFRACTIONOFROWS = 'Count as Fraction of Rows';
    public static COUNTASFRRCTIONOFTOTAL = 'Count as Fraction of Total';
    public static COUNTOFTICKETID = 'Number of tickets';
    public static COUNTOFTOTALTASKS = 'Count of total tasks';
    public static COUNTUNIQUEVALUES = 'Count Unique Values';
    public static COURCOLUMNSESEQUENCEDESCRIPTION = 'Specify the order of this course in relation to other courses.';
    public static COURSE = 'Course';
    public static COURSECONTENT = '[COURSE] contents';
    public static COURSES = 'Courses';
    public static COURSESECTION = 'Course section';
    public static CREATEARTICLE = 'Create Article';
    public static CREATECUBE = 'Create .cub file';
    public static CREATED = 'Created';
    public static CREATEDAT = 'Created at';
    public static CREATEDBY = 'Created by';
    public static CREATEDBYTT = 'The name of the person who created this ticket';
    public static CREATEDDATE = 'Date Created';
    public static CREATEDOCUMENT = 'Create a document';
    public static CREATEEXAMPLELIST = 'Create Example List';
    public static CREATELOCALCUBE = 'Create local .cub file';
    public static CREATENEWAPP = 'New';
    public static CREATENEWAPPOINTMENTIN = 'Add new event in the selected calendar';
    public static CREATENEWAPPOINTMENTPERMISSIONONSP = 'You don^t have permission to create a new event. Please talk to the SharePoint administrator.';
    public static CREATENEWTEMPLATELIB = 'Create a templates library';
    public static CREATESHORTCUT = 'Create shortcut';
    public static CREATESQLDATABASE = 'Create a new database on an MS SQL Server';
    public static CREATETASKFROMEMAIL = 'Create task from selected e-mail';
    public static CREATETASKTT = 'Creates a task based on this HelpDesk ticket in your personal tasks';
    public static CREATETICKET = 'Convert';
    public static CREATETICKETIN = 'Convert e-mail to ...';
    public static CREATINGCHARTS = 'Creating tables and charts';
    public static CREATINGCOLUMN = 'Creating column';
    public static CREATINGDATABASE = 'Creating [PRODUCT] database, please wait...';
    public static CREATINGDOCUMENTFROMTEMPLATE = 'Creating a document based on the selected template';
    public static CREATINGEXCELREPORT = 'Creating Report';
    public static CREATINGITEM = 'Creating item';
    public static CREATINGLIST = 'Creating list';
    public static CREATINGLOGIN = 'Creating login, please wait...';
    public static CREATINGNEWITEMS = 'Creating new items';
    public static CREATINGPFHDEXCELREPORT = 'Creating [PRODUCT] Excel Report';
    public static CREATINGTABLE = 'Creating database table';
    public static CREATINGTMLIB = 'Creating the TMTemplates library';
    public static CREDENTIALS = 'Enter correct username and password';
    public static CREDENTIALSTORE = 'Credential Store';
    public static CUBENAME = 'Cubename';
    public static CUBEPATH = 'Path to .cub file';
    public static CURRENCYALIGN = 'Currency align';
    public static CURRENCYSYMBOL = 'Currency symbol';
    public static CURRENTLISTCAPTION = 'Current Tasks List: [KTMLISTCAPTION]';
    public static CURRENTMONTH = 'Current month';
    public static CURRENTRESPONSIBLE = 'Current Responsible';
    public static CURRENTSITE = 'Current Site';
    public static CURRENTWEEK = 'Current week';
    public static CUSTOMER = 'Customer';
    public static CUSTOMFIELDS = 'Custom Fields';
    public static CUSTOMFIELDSLIST = 'Custom fields list:';
    public static CUSTOMPROPERTIES = 'Custom properties';
    public static CUSTOMPROXYSETTINGS = 'Other proxy settings';
    public static CUSTOMVIEWALREADYEXISTS = 'Custom view ^[NAME]^ already exists. <BR>Do you want to overwrite it?';
    public static CUSTOMVIEWS = 'Custom Views';
    public static CUSTOMVIEWSAVEDSUCCESSFULLY = 'Custom view saved successfully.';
    public static CUSTOMYESORNO = 'Yes/No';
    public static CUT = 'Cut';
    public static DAILY = 'Daily';
    public static DAILYLISTVIEWNAME = 'Day List';
    public static DAILYTREND = 'Daily Trend';
    public static DATABASECONNECTIONFAILED = 'Login to the SQL server failed! Please review the log in information and try again!';
    public static DATABASES = 'Databases';
    public static DATBASESETTINSSAVED = 'Database settings saved';
    public static DATE = 'Date';
    public static DATEAVGHRSOPEN = 'Average ticket time per year, quarter and month';
    public static DATECOMPLETED = 'Date completed';
    public static DATEFROM = 'From:';
    public static DATEHOURS = 'Sum of hours spent on tickets per year, quarter and month';
    public static DATENUMBER = 'Number of tickets per year, quarter and month';
    public static DATERANGE = 'Date Range';
    public static DATERATE = 'Cost per year, quarter and month';
    public static DATESAPPOINTMENTS = 'Total events found between the specified dates =';
    public static DATETO = 'To:';
    public static DAY = 'Day';
    public static DAYREPORT = 'Day Report';
    public static DAYS = 'Days';
    public static DAYSBACK = 'Days back';
    public static DAYSBEFORE = 'Days before';
    public static DBPATH = 'Please give the path for the .mdb file';
    public static DEC = 'Dec';
    public static DECEMBER = 'December';
    public static DECIMALPLACES = 'Decimal places';
    public static DECIMALSEPARATOR = 'Decimal separator';
    public static DEFAULT = 'Default';
    public static DEFAULTFOLDERFORCONVERTEDMAIL = 'Default task folder for converted e-mails';
    public static DEFAULTLIST = 'Default list:';
    public static DEFAULTVALUE = 'Default value';
    public static DEFAULTVALUES = 'Default values';
    public static DEFERRED = 'Deferred';
    public static DEFINERATEBY = 'Define rate by [TAG]';
    public static DELAYED = 'Delayed';
    public static DELETE = 'Delete';
    public static DELETEARTICLE = 'Delete article';
    public static DELETEARTICLEMSG = 'Are you sure you want to delete the article [SUBJECT]?';
    public static DELETEBELOWROWFIRST = 'Please delete the row below first.';
    public static DELETECHILD = 'Delete Child tickets';
    public static DELETEEXAMPLELIST = 'Delete Example List';
    public static DELETEEXPORTEDITEMS = 'Delete archived items';
    public static DELETEFORATLEASTONEITEM = 'You must select at least one item to delete.';
    public static DELETEITEMSUBJECT = 'Are you sure you want to delete [SUBJECT]?';
    public static DELETEMAILTOTHISPHASE = 'Move handled e-mails to this phase';
    public static DELETEPERMISSION = 'You must have Full Control permission to delete articles';
    public static DELETEPHASE = 'Are you sure you want to delete the Phase [PHASE]?';
    public static DELETEPROJECT = 'Are you sure you want to delete the project [PROJECT]?';
    public static DELETERESPOSIBLE = 'Are you sure you want to delete the responsible [RESPONSIBLE]?';
    public static DELETESELECTED = 'Delete the selected subfolders';
    public static DELETESELECTION = 'Delete selection';
    public static DELETESUBFOLDERSQUESTION = 'Do you want to delete the existing e-mails in the Sent/Received subfolders?';
    public static DELETESUBFOLDERWHENTICKETCLOSED = 'Delete subfolders when ticket has been closed';
    public static DELETETAGCATEGORYFIRST = 'Please delete the tag category first.';
    public static DELETETEMPLATE = 'Are you sure you want to delete the template [TEMPLATE]?';
    public static DELETETEMPLATEFAILS = 'Unable to delete the template!';
    public static DELETETICKET = 'Delete ticket';
    public static DELETETICKETFROMDATABASE = 'Do you want to delete the corresponding ticket information from the database as well?';
    public static DELETETIMESLOTS = 'Are you sure you want to delete the current record and any time slots below it?';
    public static DELETETOTHISPHASE = 'Move closed tasks to this phase';
    public static DELETEUSERCALENDAR = 'Are you sure you want to delete [USERNAME] and the [USERNAME] calendar?';
    public static DELETINGDATAFROMSP = 'Deleting data from SharePoint';
    public static DELETINGDEFAULTCONTENTTYPEFROMLIST = 'Deleting default content types from list';
    public static DEPARTMENT = 'Department';
    public static DESCRIPTION = 'Description';
    public static DESCSELECTCBFOLDER = 'Please select a Calendar Browser calendar to get its description';
    public static DETAILS = 'Details';
    public static DFOLDER = 'Delete folder';
    public static DIAGONAL = 'Diagonal';
    public static DIFFERENCE = 'Difference';
    public static DIGITS = 'Please enter [DIGITS] digits or less.';
    public static DIRECTION = 'Direction';
    public static DISABLEPRODUCT = 'Disable [PRODUCT]';
    public static DISABLEPRODUCTFORTHISEMAIL = 'Disable [PRODUCT] for this email';
    public static DISPLAYDATA = 'Display Data';
    public static DISPLAYRESULTS = 'Display Results';
    public static DISTRICT = 'District';
    public static DLL = 'DLL-installation, requires local administrator permissions';
    public static DOCADDEDSUCCESSFULLY = 'Document added successfully.';
    public static DOCADDFAILED = 'Failed to save the file to the library';
    public static DOCFORNAME = 'Documents for [NAME]';
    public static DOCLIDRARY = 'Document library';
    public static DOCSTATUS = 'Document status';
    public static DOCSUBMITTEDSUCCESSFULLY = 'Document(s) submitted successfully.';
    public static DOCTAGSUCCESS = 'Document tagged successfully.';
    public static DOCTYPE = 'Document Type';
    public static DOCUMENT = 'Document';
    public static DOCUMENTEXERICISEONLYFORSTUDENT = 'The "Write Document" exercises can only be performed with Student accounts.';
    public static DOCUMENTLIBRARY = 'Document Library';
    public static DOCUMENTLIBRARYDESCRIPTION = 'Docment library to store documents used in "Work with documents" exercises.';
    public static DOCUMENTLIBRARYDOESNOTEXIST = 'Document library does not exist.';
    public static DOCUMENTS = 'Documents';
    public static DOCWORKINGINFO = 'This exercise has at least one attached file. Click on "Copy" to download the file(s) to your document library.<BR>When the download is finished click on "Open" to work with the new document(s). Click on "Submit" when you are finished.';
    public static DOMAIN = 'Domain';
    public static DOMAINEXAMPLE = '(e.g. http://www.myDomain.com/helpdesk)';
    public static DOMAINOPTIONAL = 'Domain (optional)';
    public static DONE = 'Done';
    public static DONOTLIVEMONITOR = 'Don^t do auto-conversion from this account';
    public static DONOTREFRESHTHEPAGE = 'Do not refresh the page.';
    public static DONOTSHOWSUBTOTALS = 'Do not show subtotals';
    public static DONTASKAGAIN = 'Don^t ask again.';
    public static DONTMOVEMAIL = 'Don^t move mail';
    public static DONTSAVESENT = 'Don^t save sent items';
    public static DONUT = 'Donut';
    public static DONUTS = 'Donuts';
    public static DOUBLEBOOKING = 'No double-bookings are allowed in this calendar. Please select another time.';
    public static DOUBLECLICKTOFIT = 'Double click to fit';
    public static DOUBLECLICKTOREMOVESORTING = 'Double click to remove sorting';
    public static DOWNLOAD = 'Download';
    public static DOWNLOADALL = '📥 All';
    public static DOWNLOADDOCLIBSFAILED = 'Failed to download SharePoint document libraries from %s.';
    public static DOWNLOADDONETFRAMEWORK = 'Unable to find the correct .NET Framework on this machine!<BR>Please download and install .NET Framework 4.0 or above from Microsoft.com.<BR>Do you want to go to that website now?';
    public static DOWNLOADING = 'Downloading articles, please wait...';
    public static DOWNLOADINGSPDATA = 'Downloading SharePoint data';
    public static DOWNLOADLIVESDK = 'Unable to find the Windows Live ID For Client Applications SDK on this machine!<BR>Please download and install Windows Live ID For Client Applications SDK  from Microsoft.<BR>Do you want to go to that website now?';
    public static DOWNLOADREPORT = 'The [PRODUCT] report is ready. Do you want to download it?';
    public static DOWNLOADZIP = '📦 ZIP';
    public static DRAGDIMENSIONS = 'Drag Dimensions';
    public static DRAGLEFTORRIGHT = 'Please drag the {0} remaining {1} to the left or right column.';
    public static DRAGRIGHTCOLUMNTOLEFT = 'Please drag the phrases in the right column to the correct phrases in the left column.';
    public static DRAGTOCOLUMN = 'Drag to column';
    public static DRAGTORESIZE = 'Drag to resize';
    public static DRAGVALUESTOFORMULA = 'Drag values to formula';
    public static DROPANDARRANGECOLUMNS = 'Drop and arrange columns';
    public static DROPANDARRANGEREPORTFILTER = 'Drop and arrange report filter';
    public static DROPANDARRANGEROWS = 'Drop and arrange rows';
    public static DROPANDARRANGEVALUES = 'Drop and arrange values';
    public static DROPFILESHERE = 'Drop PDF files here to add them';
    public static DTSUPPORTEDDOCS = 'Unable to read current document. TXT, PDF, DOCX, PPTX and XLSX files are supported.';
    public static DUE = 'Due';
    public static DUEDATE = 'Due Date';
    public static DUPLICATEDBAPPPOINTMENTS = 'Duplicate events that already existed in the database =';
    public static DURATION = 'Duration';
    public static ECONOMY = 'Economy';
    public static EDIT = 'Edit';
    public static EDITDESCRIPTION = 'Edits the description of this ticket.';
    public static EDITEXPLABEL = 'Edit Expense Label';
    public static EDITINGNOTALLOWED = 'Custom properties cannot be edited.<BR>Please delete the old custom property and click OK.<BR>Then open the configure dialog again and create a new one.';
    public static EDITINSP = 'Edit in SharePoint';
    public static EDITTITLE = 'Edit the selected template';
    public static EFOLDER = 'Edit folder';
    public static ELEGANT = 'Elegant';
    public static EMAIL = 'E-mail';
    public static EMAILFOLDER = 'E-mail Folder';
    public static EMAILHISTORY = 'E-mail history';
    public static EMAILMOVEDTORECIEVEDSF = 'The e-mail has been saved with the ticket.<BR>Would you like to open the ticket now?';
    public static EMAILORDOMAIN = 'E-mails/Domains';
    public static EMAILPLEASE = 'Please give your e-mail address, so that we can contact you when this problem is corrected.';
    public static EMAILRECEIVED = 'E-mail Received';
    public static EMAILRECIEVED = 'Received';
    public static EMAILSENT = 'Sent';
    public static EMAILTOCALLER = 'E-mail to Caller';
    public static EMAILTOSUPPLIER = 'Supplier E-mail Template';
    public static EMAILTOSUPPLYPERSON = 'E-mail to orders recipient';
    public static EMBDEDCODEDETAILS = 'Copy the embed code for My Tasks.';
    public static EMBED = 'Embed';
    public static EMBEDCOURSE = 'Embed Course';
    public static EMBEDSUMMARY = 'Embed Summary';
    public static EMBEDTICKETURLINEMAIL = 'Embed Ticket URL in E-mail';
    public static EMPTY = 'Empty';
    public static ENABLECLOSETICKETNOTIFICATION = 'Send e-mail to caller when ticket is closed';
    public static ENABLED = 'Enabled';
    public static ENABLEDEFAULTVALUEFOREMPTYFIELD = 'Default values for empty fields';
    public static ENABLEEMAILDOMAIN = 'E-mails/Domains Settings';
    public static ENABLEEMAILTREADING = 'E-mail Threading';
    public static ENABLEITEMS = 'Enable and disable data';
    public static ENABLELIVEMONITORING = 'Enable Live Monitoring';
    public static ENABLEMETAMANDATORY = 'Make all [PRODUCT] tag fields mandatory';
    public static ENABLENEWTICKETNOTIFICATIONCALLER = 'Send e-mail to caller when ticket is created';
    public static ENABLENOTIFICATIONEMAILTOUSER = 'Send e-mail to these users/this distribution list when a new ticket is created:';
    public static ENABLEONLINETRACKING = 'Enable Automatic Tracking';
    public static ENABLEPLANNINGINFORMATION = 'Planning information';
    public static ENABLEPRODUCT = 'Enable [PRODUCT]';
    public static ENABLEPROXY = 'Enable proxy';
    public static ENABLESHORTNOTICE = 'Short notice flag';
    public static ENABLETASKMOVING = 'Move tasks between kanban boards';
    public static ENABLETICKETSTATUSDIALOG = 'Enable Ticket Status Dialog';
    public static ENCODINGPROBLEM = 'Due to a .html encoding problem, the body field is not available.<BR>Instead, the file ^OutlookEmail.msg^ is attached with this ticket.';
    public static ENDAFTERXOCCURANCES = 'End after: [X] occurence(s)';
    public static ENDAPP = 'End application';
    public static ENDBYX = 'End by: [X]';
    public static ENDDATE = 'End Date';
    public static ENDTIME = 'End Time';
    public static ENTERATTACHMENTNAME = 'Please enter an attachment name.';
    public static ENTERBOTHFIELDS = 'Please enter details in both fields.';
    public static ENTERCALLER = 'Please enter Caller Name';
    public static ENTERCALLERCATEGORY = 'Please enter Caller Category';
    public static ENTERDATABASE = 'Within 24 hours after payment your e-mail address will be entered into our user database. You will get an e-mail from support@kalmstrom.com once this is done.';
    public static ENTEREMAILIDOFORGANIZATION = 'Please enter your e-mail address and your registration key<BR>for [PRODUCT] and click Registration. <BR>You need to be connected to the Internet for this to work.';
    public static ENTERINCIDENT = 'Please enter an Incident Type';
    public static ENTERKEYDESCRIPTION = 'If you already have a registration key, enter it below to activate and register the application. You need an active internet connection for this to work. If you have no registration key, please contact <a href="mailto:sales@kalmstrom.com">sales@kalms';
    public static ENTERLOGININFO = 'Please enter login information for site:';
    public static ENTERPASSWORD = 'Please enter a password';
    public static ENTERRESPONSIBLE = 'Please enter a Responsible';
    public static ENTERRETYPEPASSWORD = 'Please retype the password';
    public static ENTERSERVERNAME = 'Please enter a Server Name';
    public static ENTERSTATUS = 'Please enter a new status';
    public static ENTERTEMPLETLIBRARYPATH = 'Please select/enter the path to the templates library';
    public static ENTERUSERNAME = 'Please enter a User Name';
    public static EQUALS = 'equals';
    public static EQUALTO = 'Equal to';
    public static EREOPENMAILMOVEDTORECIEVEDSF = 'The e-mail has been saved with the reopened ticket.<BR>Would you like to open the ticket now?';
    public static ERRCHART = 'Unable to set that chart type for this chart!" & vbCrLf & "Please select another type.';
    public static ERRCREATEFOLDER = 'Failed to create a new  folder in that location!';
    public static ERREDITFAILS = 'Your changes were not saved." & vbCrLf & "Please type exactly or select from the drop-down';
    public static ERRFAILEDCREATEFOLDER = 'Failed to create a new folder in that location!';
    public static ERRFOLDERNOTFOUND = 'The chosen folder was not found.';
    public static ERRINAPP = 'There has been an error in this application.';
    public static ERRLINE = 'Error on line';
    public static ERRMISSINGSTATS = 'Could not find the statistics file.';
    public static ERRORDESCRIPTION = 'Error Description';
    public static ERROREXECUTE = 'Error trying to run the file at';
    public static ERRORHASOCCURREDRESTARTPRODUCT = 'An error has occurred. Please restart [PRODUCT].';
    public static ERRORINLOADINGSITE = 'Error in loading the site ^[SITE]^. Please add the correct site URL in the settings.';
    public static ERRORINMOVINGTASK = 'Error in moving task. Error information: [DESCRIPTION]';
    public static ERROROCCURREDPLEASETRYAGAIN = 'An error occurred. Please try again.';
    public static ERRORWHILECONVERTINGMAIL = 'Error while converting e-mail';
    public static ERRREMOVEFOLDER = 'Failed to remove the folder';
    public static ERRRENAMEFOLDER = 'Failed to rename the folder';
    public static ERRROWFUNC = 'Unable to set the Task value for this row.';
    public static ERRROWHOURS = 'Unable to change the hours for this event.';
    public static ERRROWREAD = 'Unable to read info from a row.';
    public static ERRSENDREPORT = 'Would you like to send an e-mail with an error report?';
    public static ERRSPWRTIE = 'You don^t appear to have write permission over the SharePoint list [LIST_NAME]. Please review your permission and try again.';
    public static ERRSYSTEMERROR = 'The system error message was:';
    public static ERRTHISERROR = 'This error has occurred:';
    public static ERRTOMANYROWS = 'The period you choose has more than 99 events.<BR>Choose a shorter period to work with all of your events!';
    public static ESELLERATENUMBER = 'Order #';
    public static ESTIMATEDREMAINING = '~[SECONDS]s remaining';
    public static EVENTS = 'Events';
    public static EVENTSONEDAY = 'Events (24 h)';
    public static EVERY = 'Every';
    public static EVERYWEEKDAY = 'Every weekday';
    public static EVERYXDAYS = 'Every [X] Days';
    public static EXAMPLEDATA = 'Example Data';
    public static EXAMPLEHDDATA = 'Would you like to create example HelpDesk Tickets?';
    public static EXAMPLELIST = 'Example List';
    public static EXAMPLELISTHASBEENCREATED = 'Example list has been created.';
    public static EXAMPLELISTHASBEENDELETED = 'Example list has been deleted.';
    public static EXAMPLESLOADEDSUCESS = 'Examples loaded successfully';
    public static EXCEEDSHRSHOURS = 'Please do not enter a value that exceeds [HRS] hours.';
    public static EXCEEDSHRSLUNCH = 'Please do not enter a value that exceeds 7 hrs for lunch.';
    public static EXCELALREADYOPENMSG = 'You already have an open Excel report. Please close that Excel report and try again.';
    public static EXCELDOCUMENT = 'Excel Workbook';
    public static EXCELNOTFOUND = 'Excel is not found on your computer. Please install Microsoft Excel to use the Export to Excel feature.';
    public static EXCELOBJECTERROR = 'Problem in getting Excel reference.<BR>Either Excel is not installed or the installation is corrupt.';
    public static EXCELPATH = 'Path to the Excel Statistics file';
    public static EXCELREPORTFORAPPOINTMENTS = 'Creating Excel report for events';
    public static EXCELREPORTFORORDERS = 'Creating Excel report for orders';
    public static EXCLUDESTATUS = 'Exclude Phase';
    public static EXERCISE = 'Exercise';
    public static EXERCISECOLUMNRANDOMIZETASKSDESCRIPTION = 'Study Manager shows the tasks connected to this exercise in random order when the box is checked.';
    public static EXERCISECOLUMNSEQUENCEDESCRIPTION = 'Specify the order of this exercise in relation to other exercises.';
    public static EXERCISEORTEXTCOLUMNCHAPTERDESCRIPTION = 'Select what chapter this exercise/text should belong to.';
    public static EXERCISEREPORT = 'Exercise Report';
    public static EXERCISES = 'Exercises';
    public static EXISTING = 'Existing';
    public static EXISTINGKEYNOLONGERWORKS = 'Your existing registration key no longer works on this version of <PRODUCTNAME>. <BR> Please contact support@kalmstrom.com for more info.';
    public static EXIT = 'Exit';
    public static EXITCONFIRMATION = 'Are you sure you want to exit?';
    public static EXITWHENCUBEISCREATED = 'Exit when cube is created';
    public static EXPENSE = 'Expenses';
    public static EXPENSECHECKBOX = 'Expenses feature';
    public static EXPENSELABEL = 'Expense Label';
    public static EXPENSETT = 'Add/Edit Expenses';
    public static EXPERIENCE = 'Experience';
    public static EXPMSGBLANK = 'The Expense Label cannot have a blank value.';
    public static EXPMSGCURRSIGN = 'Don^t use a currency sign in the Expense Label.';
    public static EXPMSGSAMEVALUE = 'Two Expense Labels cannot have the same value.';
    public static EXPORT = 'Export';
    public static EXPORTARTICLESCREATEDBY = 'Export articles created by';
    public static EXPORTCURRENTKBASEARTICAL = 'Export selected item(s)';
    public static EXPORTHTMLBODY = 'Export article text in HTML';
    public static EXPORTINGARTICLE = 'Exporting article [COUNT] of [TOTAL]';
    public static EXPORTMULTIPPLEARTICAL = 'Export KBase articles';
    public static EXPORTTOEXCEL = 'Export to Excel';
    public static EXPORTTOFILE = 'Export to file';
    public static EXPORTTOPDF = 'Export to PDF';
    public static EXTRABOOKINGINFORMATION = 'Extra booking information';
    public static EXTRAFIELD = 'Extra field';
    public static EXTRAFIELDDESC = 'Extra field description';
    public static FAILEDATTACHFILE = 'Unable to attach the file';
    public static FAILEDCREATEAPPOINTMENT = 'Failed to create a new event.';
    public static FAILEDFINDFOLDER = 'Failed to find folder:';
    public static FAILEDFINDTEMPLATE = 'Failed to get the selected template!';
    public static FAILEDSAVEINFO = 'Failed to save the folder description';
    public static FAILEDSAVEREPORT = 'Failed to save report';
    public static FAILEDSAVESETTINGS = 'Failed to save settings';
    public static FAILEDSAVETAMPLATE = 'Failed to save the template!';
    public static FAILEDSAVEVALUE = 'Unable to save this value!';
    public static FAILEDTOCREATESUBFOLDER = 'Failed to create subfolder';
    public static FAILEDTODELETEAPP = 'Unable to delete the event <SUBJECT> from the calendar <NAME>. Would you like to continue working with the other events?';
    public static FAILEDTOGETREPORT = 'Failed to get selected report';
    public static FAILEDTOUSERESTRICTION = 'Failed to use restriction';
    public static FALSE = 'False';
    public static FAQ = 'FAQ';
    public static FAQBODY = 'FAQ Body';
    public static FAQDUPLICATE = 'Two FAQ cannot have the same subject.';
    public static FAQREPLY = 'FAQ Reply';
    public static FAQREPLYTT = 'Reply to the caller with a FAQ article';
    public static FEATURES = 'Features';
    public static FEB = 'Feb';
    public static FEBRUARY = 'February';
    public static FETCHINGAPPS = 'Fetching events ...';
    public static FHDPROPERTIES = '[PRODUCT] Properties';
    public static FIELDNAME = 'Field Name';
    public static FIELDS = 'Fields';
    public static FILECOPIED = 'File copied successfully.';
    public static FILEDOESNOTEXIST = 'This file does not exist.';
    public static FILEINUSED = '[PRODUCT] cannot replace the file. It is being used by another process or access denied.';
    public static FILENAME = 'File name';
    public static FILENAMEALREADYEXISTS = 'A file with that name already exists';
    public static FILEORDER = 'File order (drag to reorder):';
    public static FILEORDERHELP = 'Files will be merged in this order. Specify page ranges per file (e.g. 1-3, 5).';
    public static FILESCONVERTED = '[COUNT] file(s) converted';
    public static FILESSELECTED = '[COUNT] files selected';
    public static FILLDOWN = 'Fill Down';
    public static FILLRIGHT = 'Fill Right';
    public static FILTERBETWEENTWODATES = 'Between these dates';
    public static FILTERCOPIEDTOCLIPBOARD = 'Filter copied to clipboard';
    public static FILTEROPTIONS = 'Filter events';
    public static FILTERPRODUCTITEMS = 'Filter [PRODUCT] items';
    public static FILTERS = 'Tagged events,Partially tagged events,Both tagged and partially tagged,Not tagged events,All events';
    public static FILTERVALUES = 'Filter values';
    public static FIMAGEANDPDFEXPORTNOTSUPPORTED = 'This view does not support export to image or PDF.';
    public static FINDCLOSED = 'Find closed tickets';
    public static FINDCLOSEDBYDATE = 'Find ticket by Closed Date';
    public static FINDCREATEDBYDATE = 'Find ticket by Created Date';
    public static FINDINGCONTENTTYPESFORLIST = 'Finding content types for list';
    public static FINDINGOLDCUSTOMPROPERTIES = 'Searching for custom added user properties in [PRODUCT1]';
    public static FINDINGOLDPROBLEMCATEGORIES = 'Searching for categories in [PRODUCT1]';
    public static FINDINGOLDPROBLEMTYPES = 'Searching for category types in [PRODUCT1]';
    public static FINDOPENED = 'Find open tickets';
    public static FINDTICKET = 'Find ticket';
    public static FINISHTT = 'Closes this ticket - used when the incident is resolved.';
    public static FIRST = 'First';
    public static FIRSTRESPONSETIME = 'First response time';
    public static FIRSTROWCANNOTBEDELETE = 'The first row cannot be deleted.';
    public static FIXNOW = 'Correct now';
    public static FIXREADONLY = 'Correct those tickets that were shown in read-only mode, but were not opened by another user';
    public static FLAT = 'Flat';
    public static FOLDEREXIST = 'A folder with this name already exists. Please use another folder name.';
    public static FOLDERNAME = 'Folder name';
    public static FONT = 'Font';
    public static FONTSIZE = 'Font Size';
    public static FORMAT = 'Format:';
    public static FORMATASPERCENT = 'Format as percent';
    public static FORMATB = 'Format';
    public static FORMATCELLS = 'Format cells';
    public static FORWARD = 'Forward';
    public static FORWARDTICKET = 'Forward';
    public static FOUNDTEMPLATESINFO = 'Found [COUNTTEMPLATES] templates in [COUNTSITES] sites.';
    public static FOURTH = 'Fourth';
    public static FR = 'Fr';
    public static FREETEXT = 'Free text';
    public static FRI = 'Fri';
    public static FRIDAY = 'Friday';
    public static FRMMAINTITLE = 'Remove closed ticket subfolders';
    public static FROM = 'From';
    public static FULLSCREEN = 'Full screen';
    public static FULLTEXTSEARCH = 'Full-text search';
    public static FUNCTIONMOREDAYS = 'This version will function [DAYS] more days.';
    public static FUTUREEVENTS = 'Future Events';
    public static GENERALSETTINGS = 'General Settings';
    public static GENERATE = 'Generate';
    public static GENERATEEXCELREPORTS = 'Generate/Update Excel Reports';
    public static GETDATABASES = 'Get databases';
    public static GETEMBEDCODE = 'Embed My Tasks';
    public static GETORDERNUMBER = 'Enter the registration key below and press Registration. You must be connected to the internet for the registration to work.';
    public static GETPERMISSIONTOSWITCHTASKSLIST = 'You do not have permission to switch tasks list. Please get at least Design permission over the site.';
    public static GETVALUES = 'Get values';
    public static GLOBALSETTINGS = 'Global Settings';
    public static GLOBALSETTINGSSITE = 'Global settings site';
    public static GOTOFOLDER = 'Go to the [APP] folder';
    public static GRANDTOTALS = 'Grand totals';
    public static GRAPH = 'Chart';
    public static GRAPHTYPE = 'Chart type';
    public static GREATERTHAN = 'Greater than';
    public static GREATERTHANOREQUALTO = 'Greater than or equal to';
    public static GRID = 'Grid';
    public static GROUP = 'Group';
    public static GROUPBY = 'Group by:';
    public static GROUPGENERATEDWEBKBARTICLESBY = 'Group the generated [PRODUCT] web pages by';
    public static GROUPING = 'Drag a column header here to group by that column';
    public static HANDLED = 'Handled';
    public static HDCLIENTTOOLS = 'You need to install the <PRODUCTNAME> Client Tools to use this functionality!';
    public static HDUPDATECLIENTTOOLS = 'An updated version of <PRODUCTNAME> Client Tools is found. Please install it before you use <PRODUCTNAME>.';
    public static HEATMAP = 'Heat map';
    public static HEIGHT = 'Height';
    public static HELP = 'Help';
    public static HIDE = 'Hide';
    public static HIDEKANBANVIEW = 'Hide Kanban View';
    public static HIDEPERSONALMORE = 'Only show Tags in Personal Settings';
    public static HIDESTATISTICS = 'Hide Statistics';
    public static HIGH = 'High';
    public static HOME = 'Home';
    public static HOMEPAGESETTINGS = 'Homepage Settings';
    public static HOST = 'Host';
    public static HOSTS = 'Hosts';
    public static HOUR = 'Hour';
    public static HOURLYRATE = 'Hourly rate';
    public static HOURS = 'Hours';
    public static HOURSOPEN = 'Hours Open';
    public static HTML = 'HTML';
    public static HTMLBODY = 'HTML body';
    public static HTMLVIEWSTT = 'Kanban board, Month view with timeline and calendar, Pie chart';
    public static HYPERLINK = 'Hyperlink';
    public static IMAGE = 'Image';
    public static IMAGELINK = 'Image link';
    public static IMAGELINKCOLUMNDESCRIPTION = 'Enter the image links, one for each row. They will be shown in the order you enter them.';
    public static IMAGESIZE = 'Size of exported image';
    public static IMAGETEXT = 'Image text';
    public static IMAGETEXTCOLUMNDESCRIPTION = 'Enter the image texts, one for each row. They will be shown in random order.';
    public static IMPORTANCE = 'Importance';
    public static IMPORTANT = 'Important';
    public static IMPORTHTML = 'Import HTML-file';
    public static IMPORTINGARTICLESVERSION = 'Importing [PRODUCT1] articles to [PRODUCT2]';
    public static IN = 'in';
    public static INCEMENTALNUMBERING = 'Incremental numbering from';
    public static INCIDENTCATAVGHRSOPEN = 'Average ticket time per Incident Category';
    public static INCIDENTCATEGORYHOURS = 'Sum of hours spent on each Incident Category';
    public static INCIDENTCATEGORYLANE = 'Use Incident Categories as Lanes';
    public static INCIDENTCATEGORYNUMBER = 'Number of tickets per Incident Category';
    public static INCIDENTCATEGORYRATE = 'Cost per Incident Category';
    public static INCIDENTFORTASKCOLOR = 'Use colors for Incident Types';
    public static INCIDENTS = 'Incidents';
    public static INCIDENTVIEW = 'Incident View';
    public static INCIENTTICKETCREATED = 'Incident ticket created';
    public static INCLUDEBODY = 'Include body';
    public static INCORRECTCOSTCENTERFORMAT = 'Incorrect Cost Center format. XXX-XXX is expected.';
    public static INDENTLESS = 'Indent Less';
    public static INDENTMORE = 'Indent More';
    public static INDEX = 'Index';
    public static INFOCALENDAR = 'Information about this calendar';
    public static INFORESOURCE = 'Info about this resource:';
    public static INITIALIZINGAUDIO = 'Initializing audio';
    public static INITIALS = 'Initials';
    public static INITIALSALWAYS = 'Always use initials';
    public static INMINUTES = 'in minutes';
    public static INPROGRESS = 'In Progress';
    public static INPUTNAME = 'Please input the name or alias of the person whose calender you want to look at!';
    public static INSERTDATAINTEMPTABLE = 'Inserting data in temporary table';
    public static INSERTIMAGE = 'Insert image';
    public static INSERTLINK = 'Insert Link';
    public static INSERTMESSAGE = 'Insert this message to the reply';
    public static INSERTORDEREDLIST = 'Insert ordered list';
    public static INSERTUNORDEREDLIST = 'Insert unordered list';
    public static INSTALL = 'Install';
    public static INSTALLAPPAGAIN = 'Problem in loading components needed for [APP] to run. Please run the [APP] setup file to repair the installation. Contact support@kalmstrom.com if the issue remains after the repair.';
    public static INSTALLATIONTYPE = 'Installation type';
    public static INSTALLCOMPLETE = 'Installation was successfully completed!';
    public static INSTALLLOCALFILES = 'Install files locally to use the the application off-line';
    public static INSTALLNOW = 'Do you want to install now?';
    public static INSTALLPROBLEMS = 'Installation encountered an error.';
    public static INSTRUCTION = 'Instruction';
    public static INTEGERSUM = 'Integer Sum';
    public static INTEGRATEDSECURITY = 'Use trusted connection  - recommended';
    public static INTERGRATEDBUY = 'Purchase directly from within this application through secure integrated eSellerate payment gateway, (Automatic registration)';
    public static INVALIDCHARACTER = 'Please don^t use the character [CHARACTER]';
    public static INVALIDKBPATH = 'The folder ^[KBFOLDERNAME]^ is not a valid KBase folder.<BR>Please set the correct path to KBase in the Folder HelpDesk Settings, Other settings.';
    public static INVALIDKEY = 'This registration key is not valid or has already been used. Please contact support@kalmstrom.com to request a new key.';
    public static INVALIDLENGHT = 'You are trying to insert invalid data, or length of data is greater than SharePoint Field length.';
    public static INVALIDPRODUCTOLDFOLDER = 'The selected folder is not a valid [PRODUCT1] folder. Do you want to try again?';
    public static INVALIDRATE = 'You are trying to insert an invalid rate.';
    public static INVALIDSEATS = 'You are trying to insert an invalid number of seats.';
    public static INVALIDSITEORLOGININFO = 'The SharePoint site you requested is not available.<BR>Either the URL or the login credentials are incorrect!<BR><BR>Please review the information and try again.';
    public static INVALIDTICKETID = 'Please specify a valid Ticket ID';
    public static INVALIDTIMERANGE = 'The specified time-range is invalid.';
    public static ISDELETED = 'Deleted';
    public static ISEMPTY = 'is empty';
    public static ISGREATERTHEN = 'is greater than';
    public static ISGREATERTHENOREQUALTO = 'is greater than or equal to';
    public static ISLESSTHEN = 'is less than';
    public static ISLESSTHENOREQUALTO = 'is less than or equal to';
    public static ISNOTEMPTY = 'is not empty';
    public static ISNOTNULL = 'is not null';
    public static ISNULL = 'is null';
    public static ITALIC = 'Italic';
    public static ITEM = 'Item';
    public static ITEMADDEDMESSAGE = '[N] tasks added';
    public static ITEMDELETEDMESSAGE = '[N] tasks deleted';
    public static ITEMMODIFIEDMESSAGE = '[N] tasks modified';
    public static ITEMMOVEDORDELETE = '[PRODUCT] cannot find the item. It has been moved or deleted by another user.';
    public static ITEMNOTFOUNDINLIST = 'Something went wrong. The item may have been deleted.';
    public static ITEMPERORGANIZERNUMBERANDCOST = 'Supplies per Organizer: cost and quantity';
    public static ITEMPRICE = 'Item Price';
    public static ITEMS = 'Items';
    public static ITEMSORDEREDPERCALENDARAPPOINTMENT = 'Ordered Items per Event';
    public static ITEMUPDATEDSUCCESSFULLY = 'Item updated successfully.';
    public static JAN = 'Jan';
    public static JANUARY = 'January';
    public static JUL = 'Jul';
    public static JULY = 'July';
    public static JUN = 'Jun';
    public static JUNE = 'June';
    public static JUSTIFYCENTER = 'Justify center';
    public static JUSTIFYLEFT = 'Justify left';
    public static JUSTIFYRIGHT = 'Justify right';
    public static KALMSTROMSERVERCONNECT = 'Could not connect to the kalmstrom.com server. Please try again later.';
    public static KANBANVIEW = 'Kanban View';
    public static KBFIRSTTIME3 = 'If you don^t have one - please download it from www.kalmstrom.com and select Cancel';
    public static KBPROBLEM = 'Problem';
    public static KCFORMAT = 'Cost Center format';
    public static KCWITHORDER = 'Cost Center mandatory with order';
    public static KEY = 'Key';
    public static KEYWORDERROR = '[VALUE] is reserved for TimeCard keywords, Please use any other value';
    public static KTMACTIVITY1 = 'Brainstorming';
    public static KTMActivity2 = 'Request approval';
    public static KTMActivity3 = 'Plan';
    public static KTMActivity4 = 'Deploy';
    public static KTMActivity6 = 'Communicate with early adopters';
    public static KTMActivity7 = 'Write documentation';
    public static KTMActivity8 = 'Research';
    public static KTMActivity9 = 'Prepare presentation';
    public static KTMCHANGEINSETTINGS = 'The Kanban Task Manager configuration has been changed. Please refresh the page to get your tasks synced with the new settings.';
    public static KTMCheckTemplate1 = 'AIDA:Attention,Intererest,Desire,Action';
    public static KTMCheckTemplate2 = 'SWOT:Strengths,Weaknesses,Opportunities';
    public static KTMCheckTemplate3 = 'PPP:Progress,Problems,Plans';
    public static KTMEXACTIONCOMMENT = 'Needs to be fully researched and discussed further. Setting due date to a week from now.';
    public static KTMEXACTIONNAME = 'Needs research';
    public static KTMEXBODY1 = 'Customer: I have Microsoft Exploder.';
    public static KTMEXBODY10 = 'Customer: Excuse me can I use this disk? It has a hole in it.';
    public static KTMEXBODY13 = 'Customer: Now what do I do? Tech Support: What is the prompt on the screen? Customer: It^s asking for ^Enter Your Last Name.^ Tech Support: Ok, so type in your last name. Customer: How do you spell that?';
    public static KTMEXBODY14 = 'Customer: I received the software update you sent, but I am still getting the same error message. Tech Support: Did you install the update? Customer: No.Oh, am I supposed to install it to get it to work?';
    public static KTMEXBODY15 = 'Customer: I^m having trouble installing Microsoft Word. Tech Support: Tell me what you^ve done. Customer: I typed ^A: SETUP^. Tech Support: Ma^am, remove the disk and tell me what it says. Customer: It says ^[PC manufacturer] Restore and Recovery disk^. T';
    public static KTMEXBODY16 = 'Customer: Do I need a computer to use your software ? Tech Support: ?@#$ ?';
    public static KTMEXBODY17 = 'Tech Support: Ok, in the bottom left hand side of the screen, can you see the ^OK^ button displayed ? Customer : Wow.How can you see my screen from there ?';
    public static KTMEXBODY18 = 'Tech Support: What type of computer do you have ? Customer : A white one.';
    public static KTMEXBODY19 = 'Customer: I^m going to be using Windows NT.Should I get the Server or Workstation version? Tech Support: Well, are you using it as a workstation or as a server? Customer: A server.So, which one do I get? Tech Support: The server version perhaps? Customer:';
    public static KTMEXBODY2 = 'Customer: How do I print my voicemail?';
    public static KTMEXBODY20 = 'Tech Support: Type ^A: ^ at the prompt. Customer: How do you spell that?';
    public static KTMEXBODY21 = 'Customer: I can^t log in to my account. Tech Support: Ok, let^s look at your configuration. Customer: Ok...but I know that my User ID is case sensitive. Tech Support: Yes it is.Ok, what does it say in the ^User ID^ field ? Customer : Like I said, ^Case Se';
    public static KTMEXBODY22 = 'Tech Support: What^s on your screen right now ? Customer : A stuffed animal that my boyfriend got me at the grocery store.';
    public static KTMEXBODY23 = 'Tech Support: What operating system are you running ? Customer : Pentium.';
    public static KTMEXBODY24 = 'This is a true story from the WordPerfect helpline.Needless to say, the help desk employee was fired; however, he / she is currently suing the Word Perfect organization for Termination without Cause. Actual dialogue of a former WordPerfect Customer Suppor';
    public static KTMEXBODY25 = 'A woman called the Canon help desk with a problem with her printer.The Tech asked her if she was running it under Windows. The woman responded, No, my desk is next to the door.But that^s a good point.The man sitting in the cubicle next to me is under a wi';
    public static KTMEXBODY26 = 'Tech Support: OK Bob, let^s press the control and escape keys at the same time.That brings up a task list in the middle of the screen.Now type the letter ^P^ to bring up the Program Manager. Customer: I don^t have a ^P^. Tech Support: On your keyboard, Bo';
    public static KTMEXBODY27 = 'Overheard in a computer shop: Customer: I^d like a mouse mat, please. Salesperson: Certainly sir, we^ve got a large variety. Customer: But will they be compatible with my computer ?';
    public static KTMEXBODY28 = 'I once received a fax with a note on the bottom to fax the document back to the sender when I was finished with it, because he needed to keep it';
    public static KTMEXBODY29 = 'Customer in computer shop: Can you copy the Internet onto this disk for me ?';
    public static KTMEXBODY3 = 'Customer: I don^t need any of that SQL stuff-I Just want a database!';
    public static KTMEXBODY30 = 'Customer: So that^ll get me connected to the Internet, right ? Tech Support: Yeah. Customer: And that^s the latest version of the Internet, right ? Tech Support: Uhh...uh....uh...yeah.';
    public static KTMEXBODY31 = 'Tech Support: All right...now double - click on the File Manager icon. Customer: That^s why I hate this Windows - because of the icons - I^m a Protestant, and I don^t believe in icons. Tech Support: Well, that^s just an industry term sir.I don^t believe i';
    public static KTMEXBODY32 = 'Customer: My computer crashed! Tech Support: It crashed ? Customer : Yeah, it won^t let me play my game. Tech Support: All right, hit Control - Alt - Delete to reboot. Customer: No, it didn^t crash - it crashed. Tech Support: Huh ? Customer : I crashed my';
    public static KTMEXBODY33 = 'I had been doing Tech Support for Hewlett - Packard^s DeskJet division for about a month when I had a customer call with a problem I just couldn^t solve.She could not print yellow.All the other colors would print fine, which truly baffled me because the o';
    public static KTMEXBODY34 = 'A man attempting to set up his new printer called the printer^s tech support number, complaining about the error message: Can^t find the printer. On the phone, the man said he even held the printer up in front of the screen, but the computer still couldn^';
    public static KTMEXBODY35 = 'And another user was all confused about why the cursor always moved in the opposite direction from the movement of the mouse.She also complained that the buttons were difficult to depress.She was very embarrassed when we asked her to rotate the mouse so t';
    public static KTMEXBODY36 = 'An unfailingly polite lady called to ask for help with a Windows installation that had gone terribly wrong: Customer: I brought my Windows disks from work to install them on my home computer. Training stresses that we are not the Software Police, so I let';
    public static KTMEXBODY37 = 'This guy calls in to complain that he gets an Access Denied message every time he logs in.It turned out he was typing his username and password in capital letters.Tech Support: Ok, let^s try once more, but use lower case letters. Customer: Uh, I only have';
    public static KTMEXBODY38 = 'A worker for a local ISP told me ^Frequently we receive phone calls that go something like this: Customer: Hi.Is this the Internet ? ^ Some people pay for their online services with checks made payable to The Internet';
    public static KTMEXBODY39 = 'For a computer programming class, I sat directly across from someone, and our computers were facing away from each other.A few minutes into the class, she got up to leave the room.I reached between our computers and switched the inputs for the keyboards.S';
    public static KTMEXBODY4 = 'Tech Support: What does the screen say now? Customer: It says, ^Hit ENTER when ready^. Tech Support: Well? Customer: How do I know when it^s ready?';
    public static KTMEXBODY40 = 'I have a friend who just bought a computer and was instructed to load a program by typing A: and then the name of the program.My friend told me it would not work because his keyboard was no good.He said he couldn^t type the dot over dot thingie and that e';
    public static KTMEXBODY41 = 'I Received this Email from a friend: CanYouFixTheSpaceBarOnMyKeyboard ?';
    public static KTMEXBODY5 = 'Customer: I have a long distance modem.';
    public static KTMEXBODY6 = 'Customer: I don^t have a space bar.';
    public static KTMEXBODY7 = 'Customer: You^ve got to fix my computer.I urgently need to print a document, but the computer won^t boot properly. Tech Support: What does it say? Customer: Something about an error and non-system disk. Tech Support: Look at your machine. Is there a flopp';
    public static KTMEXBODY8 = 'Tech Support: Just call us back if there^s a problem.We^re open 24 hours. Customer: Is that Eastern time?';
    public static KTMEXBODY9 = 'Tech Support: Ok, now click your left mouse button. Customer: (silence) But I only have one mouse.';
    public static KTMEXCELREPORTS = 'Kanban Task Manager Reports';
    public static KTMExLane2 = 'Sales';
    public static KTMExLane3 = 'Contracts';
    public static KTMExLane4 = 'Legal';
    public static KTMExLane5 = 'Fulfillment';
    public static KTMExProj1 = 'Planting the garden';
    public static KTMExProj10 = 'Health and safety program';
    public static KTMExProj2 = 'Building a playground';
    public static KTMExProj3 = 'Trip to India';
    public static KTMExProj4 = 'School reunion';
    public static KTMExProj5 = 'Sales team meeting';
    public static KTMExProj6 = 'Team meeting';
    public static KTMExProj7 = 'Composing instructions manual';
    public static KTMExProj8 = 'Insurance for cars';
    public static KTMExProj9 = 'Staff training day';
    public static KTMExSubj1 = 'Invoice customer';
    public static KTMExSubj10 = 'Select samples before the meeting';
    public static KTMExSubj2 = 'Send receipts';
    public static KTMExSubj3 = 'Transcribe meeting notes';
    public static KTMExSubj4 = 'Order rooms';
    public static KTMExSubj5 = 'File the papers';
    public static KTMExSubj6 = 'Book time at the ministry';
    public static KTMExSubj7 = 'Send notices';
    public static KTMExSubj8 = 'Forward memos';
    public static KTMExSubj9 = 'Order invitations and distribute';
    public static KTMExtra1 = 'East';
    public static KTMExtra2 = 'West';
    public static KTMExtra3 = 'North';
    public static KTMExtra4 = 'South';
    public static KTMNOTCONFIGUREDNOTASK = 'Kanban Task Manager has not been configured yet, so you cannot create a task.<BR>Do you want to configure Kanban Task Manager?';
    public static KTMREPORTS = 'KTM Reports';
    public static KTMUPGRADEMSG = 'Upgrading tasks of older version to newer version, please wait...';
    public static LABEL = 'Label';
    public static LANDCARE = 'Landcare';
    public static LANDSCAPE = 'Landscape';
    public static LANE = 'Lane';
    public static LANEDESCRIPTION = 'Lane Description';
    public static LANENAME = 'Lane Name';
    public static LANES = 'Lanes';
    public static LANGUAGE = 'Language';
    public static LANGUAGEOPTION = 'Language Options';
    public static LAODINGTAGSUSINGGOOGLE = 'Finding document tags using Google Natural Language.';
    public static LAST = 'Last';
    public static LASTMODIFIEDAT = 'Last modified at:';
    public static LASTMODIFIEDBY = 'Last modified by:';
    public static LASTMONTH = 'Last month';
    public static LASTWEEK = 'Last week';
    public static LAUNCH = 'Launch';
    public static LAYOUT = 'Layout';
    public static LAYOUTOPTIONS = 'Layout options';
    public static LEFT = 'Left';
    public static LEFTALTERNATIVES = 'Left alternatives';
    public static LEFTALTERNATIVESCOLUMNDESCRIPTION = 'Enter the correct alternatives of the left column, one for each row.';
    public static LEFTCAPTION = 'Left heading';
    public static LEFTHEADINGCOLUMNDESCRIPTION = 'Enter the heading of the left column.';
    public static LEFTPART = 'Left part';
    public static LEFTPARTCOLUMNDESCRIPTION = 'Enter the beginnings of the sentences, one for each row. They will be shown in the order you enter them.';
    public static LESS = 'Less';
    public static LESSTHAN = 'Less than';
    public static LESSTHANOREQUALTO = 'Less than or equal to';
    public static LGNLOADINGDATAFROMDATABASE = 'Loading data from database';
    public static LGNWRONGALTERNATIVESHERE = 'Write the wrong alternatives here.';
    public static LIBRARYCREATEDEXDATA = 'The TMTemplates library has been created. Would you like to add example templates?';
    public static lICENSE = 'License';
    public static LIMITEDSETTINGS = 'Limited User Settings';
    public static LINE = 'Line';
    public static LIST = 'List';
    public static LISTALREADYEXISTS = 'A list with that title already exists!';
    public static LISTCANNOTBEFOUNDINSP = 'This list cannot be found on the SharePoint site.';
    public static LISTCREATED = 'List created!';
    public static LISTENTOWORDS = 'Listen to words';
    public static LISTFAILCONFIG = 'Error in connecting to SharePoint list <LISTNAME>.<BR>The selected Sharepoint list appears to be invalid or no longer exist in your SharePoint site.<BR>Do you want to remove it from the HOSP settings?';
    public static LISTFAILTICKET = 'Error in connecting to SharePoint list <LISTNAME>.<BR>Please use the HOSP Configuration tool to remove this particular list if it no longer exists in your SharePoint site.';
    public static LISTONSITE = '%1s on %2s';
    public static LISTPERMISSION = 'To create a list you must have design or full control over the SharePoint site.';
    public static LISTSETTINGS = 'List Settings';
    public static LISTUNIQUEVALUES = 'List Unique Values';
    public static LISTVALIDATING = 'Problem in validating list. Please contact support@kalmstrom.com.';
    public static LIVEMONITORING = 'Live Monitoring';
    public static LNDADDTODB = 'Add to DB >>';
    public static LNOLLISTS = 'Office Live lists';
    public static LOADEXAMPLEDATA = 'Create Example Data';
    public static LOADINGAUDIO = 'Loading audio';
    public static LOADINGDATA = 'The data from the SharePoint list is being populated. This might take several minutes.';
    public static LOADINGDOCCONTECT = 'Loading document content.';
    public static LOADINGDOCINFORMAION = 'Loading information about document.';
    public static LOADINGFIRSTTIME = 'Loading settings for this installation for the first time, please wait...';
    public static LOADINGGLOBALSET = 'Loading Global Settings';
    public static LOADINGLOCALSET = 'Loading Local Settings';
    public static LOADINGPRODUCTFOLDER = 'Loading the [PRODUCT] folder';
    public static LOADINGPRODUCTSETTINGSPLEASEWAIT = 'Loading [PRODUCT] settings, please wait...';
    public static LOADINGSET = 'Loading Settings';
    public static LOADINGVIEW = 'Loading view';
    public static LOADSETTINGSFAILED = 'The [PRODUCT] settings were not loaded correctly,<BR>Please open the [PRODUCT] settings and click OK to save them.';
    public static LOCATION = 'Location';
    public static LOCKEDBY = 'Locked by';
    public static LODINGDATAFROMSP = 'Loading data from SharePoint';
    public static LOGFILES = 'Log files';
    public static LOGFILESFOUND = 'X logfiles found';
    public static LOGFILESPATH = 'Path to logfiles';
    public static LOGIN = 'Login';
    public static LOGINEMPTY = 'One of the required fields is empty!<BR>Please try again.';
    public static LOGS = 'Logs';
    public static LOOKINGFORSITECONTENTTYPES = 'Looking for site content type';
    public static LOOKPUITEMDELETEALART = 'This item in the [LISTA] list cannot be deleted by SP Archive, because it is related to an item in the [LISTB] list.  Please delete the item in SharePoint instead.';
    public static LOW = 'Low';
    public static LOWANDHIGH = 'Low And High';
    public static LUNCHBREAK = 'Lunch break';
    public static LUXURY = 'LUXURY';
    public static MAILFOLDERADDREMOVE = 'Add/Remove e-mail folders to monitor';
    public static MAILFOLDERS = 'E-mail Folders';
    public static MAILINFO = 'The added folder will be monitored by [PRODUCT], and incoming e-mails will be automatically converted into tickets.';
    public static MAILSPERCENTPERPHASE = 'Average of E-mails % completed per Phase';
    public static MAILSPERLANEANDPHASE = 'E-mails per Lane and Phase';
    public static MAILSPERPHASEANDLANE = 'E-mails per Phase and Lane';
    public static MAILSPPERCENTPERLANE = 'Average of E-mails % completed per Lane';
    public static MAINTENANCE = 'Maintenance';
    public static MAKEBOOKING = 'New booking';
    public static MAKEMEETING = 'Would you like to invite this calendar to a meeting? A new meeting will be created in your personal calendar and this resource will be invited to the meeting!';
    public static MANAGE = 'Manage';
    public static MANAGEUSERS = 'Manage Users';
    public static MANDATORY = 'Mandatory value';
    public static MANUALATTACHMENTEMAIL = 'Do not include attachments in manual e-mails to callers.';
    public static MANUALLY = 'manually';
    public static MAPEMAIL = 'Map e-mails for default tag';
    public static MAPRESPONSIBLE = 'Map Responsible';
    public static MAPTOKBASE = 'Map to KBase';
    public static MAR = 'Mar';
    public static MARCH = 'March';
    public static MARKASCOMPLETED = 'Mark as completed';
    public static MARKNEWAPPWITHDEFAULT = 'Tag new events with default values';
    public static MASSEMAIL = 'Mass e-mail';
    public static MASSEMAILTIP = 'E-mail to all callers in a category';
    public static MAX = 'Max';
    public static MAXIMUM = 'Maximum';
    public static MAXSIZEATTACHMENT = 'maximum file size';
    public static MAXVERSIONSTOKEEP = 'Max versions to keep';
    public static MAY = 'May';
    public static MEDIAN = 'Median';
    public static MEETINGTAGSDOMAINS = 'Domains for body tags';
    public static MEMBERS = 'Members';
    public static MERGE = 'Merge';
    public static MERGEDHELP = 'All files combined into a single PDF document.';
    public static MERGETICKETS = 'Merge Tickets';
    public static MERGINGFILES = 'Merging files into one PDF...';
    public static MERGINHTICKETWAIT = 'Merging Tickets. This might take several minutes.';
    public static MESSAGERECEIVED = 'Message received';
    public static MESSAGESENT = 'Message Sent';
    public static META = 'Tag';
    public static METAEMPTYMESS = 'The TimeCard tagging fields are mandatory and cannot be left empty!';
    public static METASUPERCATEGORY = 'Tag supercategory';
    public static MIDDLE = 'Middle';
    public static MILE = 'Mileage';
    public static MILECOST = 'Mileage Cost';
    public static MIN = 'Min';
    public static MINIMUM = 'Minimum';
    public static MINUTE = 'Minute';
    public static MINUTES = 'Minutes';
    public static MISSINGPERMISSION = 'Unfortunately you don^t have the permission needed to perform this action.';
    public static MISSINGVALUE = 'Missing value';
    public static MO = 'Mo';
    public static MODERN = 'Modern';
    public static MODIFIEDBY = 'Modified by';
    public static MODIFIEDDATE = 'Modified';
    public static MODIFYINGLISTTITLE = 'Modifying list title';
    public static MON = 'Mon';
    public static MONDAY = 'Monday';
    public static MONTH = 'Month';
    public static MONTHLY = 'Monthly';
    public static MONTHLYRECURRINGDAY = 'Day [X] of every [Y] month(s)';
    public static MONTHLYRECURRINGFIRSTDAY = 'The first [X] of every [Y] month(s)';
    public static MONTHS = 'Months';
    public static MONTHVIEW = 'Month View';
    public static MORE = 'More';
    public static MOREDAYS = 'more days.';
    public static MORETHANONEEMAILCONVERTINTOITEMS = '[N] e-mails found in the [FOLDER] folder have been converted into list items.';
    public static MOVETO = 'Move to';
    public static MOVETOPHASE = 'Do you want to move [SUBJECT] to [PHASENAME]?';
    public static MOVETOTT = 'Where the e-mail being replied to should  be moved. Default is no move.';
    public static MSGADDCATEGORY = 'Please add a category before you create an article.';
    public static MSGADDPHASE = 'Please add a phase before you create a task';
    public static MSGADDPROJECT = 'Please add a project before you create a task';
    public static MSGADDREPOSIBLE = 'Please add a responsible before you create a task';
    public static MSGADDSPLIST = 'No SharePoint list is configured in [PRODUCT]. Do you want to add a list now?';
    public static MSGADDTYPE = 'Please add a type before you create an article.';
    public static MSGAPPPARTCONFIG = 'To use the [PRODUCT] App Part, you have to first configure it from its APP. <BR>Now you will be redirected to [PRODUCT] APP for configuration.';
    public static MSGCONFIRMDELETE = 'Are you sure you want to remove all the selected <BR> closed ticket folders from the Folder HelpDesk folder? <BR><BR> Note: all e-mails in the selected Ticket ID subfolders <BR> will be removed permanently!';
    public static MSGDELETE = 'Are you sure you want to delete this row?';
    public static MSGDELETETASKCONFIRMATION = 'Are you sure you want to delete the task with the subject [SUBJECT]?';
    public static MSGDICERROR = 'ERROR<BR>Attempting to create a new Scripting Dictionary object.<BR>This component is usually installed with Internet Explorer 4.0 or later.<BR>Please download the Windows Scripting Runtime from Microsoft Downloads to resolve this issue.';
    public static MSGDUPLICATE = 'The value [ITEM] already exists in the column [COLUMNNAME].<BR>Please try another value.';
    public static MSGESELLERATENOTFOUND = 'eSellerateControl365.dll not found. Please run HelpDeskOSPSetup.exe to get SellerateControl365.dll again.';
    public static MSGMULTITIME = 'This list is already added. The same list cannot be added twice.';
    public static MSGNOOLFOLDER = 'This folder cannot be monitored!<BR>Please select another folder.';
    public static MSGPERMISSION = 'You do not have appropriate permission. To define SharePoint list settings you need to have Full Control or Design permission.';
    public static MSGTHREADINGFIELDREQUIRED = 'E-mail threading cannot be set for the list [SITEURL].<BR>Please check that you have made all necessary settings.<BR>Refer to the [PRODUCT] manual for details.';
    public static MSGWORDLIMIT = 'You cannot insert more than 255 characters.';
    public static MULTIPLE = 'Multiple';
    public static MULTIPLECHOICE = 'Multiple choice';
    public static MULTIPLEVALUES = 'Multiple measures';
    public static MUTIPLETICKETDELETMESSAGE = 'Do you want to delete the selected tickets?';
    public static MYOPENTASKS = 'My Tasks';
    public static NAGDELETETICKET = 'Are you sure you want to delete the ticket [SUBJECT]?';
    public static NAME = 'Name';
    public static NAMEFORREPORT = 'Please give a name for this report.';
    public static NAMEWEBPAGESBY = 'Name the web pages by';
    public static NAMEWILLREPLACEEXISTINGREPORT = 'Saving with this report name will replace an existing report';
    public static NATURALHERITAGETRUST = 'Natural Heritage Trust';
    public static NEEDCONTRIBUTEPERMISSIONONTMLIBRARY = 'You need to have Contribute permission over the SharePoint templates library to download templates';
    public static NENTERINCIDENT = 'Please enter at least one Incident Type before you save the settings.';
    public static NENTERRESPONSIBLE = 'Please enter at least one Responsible before you save the settings.';
    public static NENTERSTATUS = 'Please enter at least one Status before you save the settings.';
    public static NEW = 'New ticket';
    public static NEWACTIVITY = 'New Activity';
    public static NEWAPPOINTMENTS = 'New Events';
    public static NEWAPPTEMPLATE = 'New Event';
    public static NEWARTICLE = 'New Article';
    public static NEWCALLER = 'New Caller';
    public static NEWEMAIL = 'New E-mail';
    public static NEWENTRY = '---New entry---';
    public static NEWFAQ = 'New FAQ';
    public static NEWFOLDER = 'New folder';
    public static NEWKTMTASK = 'New KTM Task';
    public static NEWOFFICELIVELIST = 'Add a new Office Live list';
    public static NEWROWLINE = 'Click here to add a new row';
    public static NEWSPEVENT = 'Create a new [PRODUCT] event.';
    public static NEWTASK = 'New Task';
    public static NEWTEMPLATE = 'Select Template';
    public static NEWTEMPLATENAME = 'Please give a name for the new template.';
    public static NEWTICKET = 'Blank Ticket';
    public static NEWTICKETIN = 'Blank ticket in ...';
    public static NEXT = 'Next';
    public static NEXTAPPOINTMENT = 'Next Event';
    public static NEXTEXERCISE = 'Next exercise';
    public static NEXTMONTH = 'Next month';
    public static NEXTWEEK = 'Next week';
    public static NO = 'No';
    public static NOACTIVENETCONNECTION = 'There is no active Internet connection.';
    public static NOAPPOINTMENT = 'There are no events between the selected dates.';
    public static NOAPPOINTMENTHASBEENREPORTEDFORSELECTEDDATERANGE = 'No event has been reported for the selected date range.';
    public static NOAPPSFOUND = 'No events found.';
    public static NOARTICLE = 'There is no article in the database';
    public static NOARTICLEFOUND = 'No article with [PARAMETER] was found';
    public static NOARTICLET = '[PRODUCT] Excel Export finds no articles to export. Please check your export filter and try again.';
    public static NOASPSITE = 'Cannot connect to the site.';
    public static NOATTACHMENTCALLEREMAIL = 'Do not include attachments in automatic e-mails to callers.';
    public static NOAUDIOFILEATTACHEDFORTHISTASK = 'No audio file is attached for this task';
    public static NOCALENDARDS = 'No calendars found';
    public static NOCALENDARS = 'No calendars found!';
    public static NOCOMPLETEDTASKS = 'There are no completed tasks';
    public static NOCONNECTION = 'Unable to connect to [SQL SERVER].<BR> Please review the connection string settings! System Error:';
    public static NOCONNECTIONREVIEWCREDENTIALS = 'Cannot connect to [SQL Azure SERVER]. Please review the credentials!';
    public static NOCONNECTIONSQLAZURE = 'Cannot connect to [SQL Azure SERVER]. There is a network or internet problem. & vbCrLf & Do you want to try again?';
    public static NOCONNECTIONSQLAZURETRYAGAIN = 'Cannot reach the SQL Azure server. There is a network or internet problem.';
    public static NOCOURSEPUBLISHEDYET = 'No course published  yet.';
    public static NODATAFOUNDINSELECTEDLIST = 'No data found in the selected list.';
    public static NODATAREPORTEDYET = 'No data has been reported yet. Please report time before you generate statistics reports.';
    public static NODATATOGENERATEEXCELREPORTS = 'There is no data to generate Excel reports. Please create some items and try again.';
    public static NODATATOPRINT = 'There is no data to print.';
    public static NODESCRIPATIONCALENDAR = 'There is no description for the [NAME] calendar.';
    public static NODIRECTEXECUTION = 'This application is not intended to be run directly!<BR>Rather it has to be invoked from within the [PRODUCT] Addin.';
    public static NODOCUMENTSELECTED = 'Please select at least one document.';
    public static NODOUBLES = 'You must not have any duplicates in this list!';
    public static NODUPLICATE = 'Duplicate values are not allowed.';
    public static NOEND = 'No end date';
    public static NOEXCELREPORTSETTINGSOPEN = 'The [PRODUCT] Excel report cannot be generated because the settings or statistics is running. Please close the settings or statistics and try again.';
    public static NOFAQFOUND = 'No FAQ found';
    public static NOINTERNETCONNECTION = 'You are not connected to the internet. Please connect to the internet and try again';
    public static NOITEMS = '# of items';
    public static NOKB = 'The KBase folder ^[KBFOLDERNAME]^ does not exist.<BR>Please enter the correct KBase folder in the Folder HelpDesk Settings, Other settings.';
    public static NOLISTFOUND = 'No list found to configure [PRODUCT]';
    public static NONE = 'None';
    public static NONEEDTOMODIFYCONTENTTYPES = 'No need to modify content types.';
    public static NONEWFIELDSTOADD = 'No new fields to add';
    public static NONEXISTANTCALLERCATEGORY = 'The Caller category you have entered does not exist yet!<BR>Would you like to add it?';
    public static NONEXISTANTPROBLEMTYPE = 'The Incident Type you have entered does not exist yet!<BR>Would you like to add it?';
    public static NONEXISTANTRESPONSIBLE = 'The Responsible you have entered does not exist yet!<BR>Would you like to add it?';
    public static NONEXISTANTSTATUS = 'The Status you have entered does not exist yet!<BR>Would you like to add it?';
    public static NONEXISTENTVALUES = 'Non-existent values in the ticket form';
    public static NONEXISTENTVALUESDESCRIPTION = 'Should Folder HelpDesk automatically save non-existent values for the following drop-down list in the ticket form?';
    public static NOOFSTUDENTHAVEBEENADDED = '[COUNT] Student(s) added.';
    public static NOOFSTUDENTREMOVED = '[COUNT] Student(s) removed.';
    public static NOOFSTUDYGROUPREMOVED = '[COUNT] Study Group(s) removed.';
    public static NOONLINETICKETSFOUND = 'No online tickets found';
    public static NOOVERDUETASKS = 'There are no overdue tasks';
    public static NOPARENTTICKET = 'Not able to find Parent ticket ID. Please try again.';
    public static NOPERSONALSETTING = 'No personal settings found';
    public static NORECORDFOUND = 'No record found.';
    public static NORECORDFOUNDDATE = 'No bookings found at the selected date.';
    public static NORECURRINGTASK = 'You cannot create a recurring task in Kanban Task Manager.';
    public static NORESOURCESFOUND = 'No resources found!';
    public static NORESULTSFORSPECIFIRDSPLIST = 'No results obtained for the specified SharePoint list.';
    public static NORESULTSMATCH = 'No results match.';
    public static NORMAL = 'Normal';
    public static NORTH = 'North';
    public static NOSAVEDCUSTOMVIEWSFOUND = 'No saved custom views were found.';
    public static NOSEARCHTEXT = 'Enter text to search';
    public static NOSERVERCONNECTION = '[PRODUCT] is not able to connect to the server for registration.<BR>Please try again later.';
    public static NOSETTINGFOUNDFROMSP = 'No [PRODUCT] settings found. Please configure [PRODUCT] first.';
    public static NOSTUDENTINSELECTEDSTUDYGROUP = 'There is no student in the selected study group.';
    public static NOSTUDYGROUPFOUND = 'No Study Group found. Please add a Study Group first. ';
    public static NOSUBJECT = 'Please add a task subject.';
    public static NOTASKINTHISEXERCISE = 'There are no more tasks in this exercise.';
    public static NOTASKTOCREATEREPORT = 'There are no tasks to create Excel reports from.';
    public static NOTCALEDARFOLDER = 'The selected folder is not a calendar folder. Do you want to try again?';
    public static NOTEMPLATELIBRARIESFOUND = 'SharePoint Search cannot find any template libraries called TMTemplates in your organization. Would you like to create one now?';
    public static NOTEMPLATESFOUNDWITHSEARCH = 'No template with "[SEARCH]" was found.';
    public static NOTEMPLATESPUBLISHED = 'No templates are published yet.';
    public static NOTEQUALS = 'not equals';
    public static NOTEQUALTO = 'Not equal to';
    public static NOTHINGSEL = 'Nothing selected';
    public static NOTICKET = 'No ticket found';
    public static NOTICKETFOUND = 'No ticket with [PARAMETER] was found';
    public static NOTICKETSTOCREATEEXCELREPORTS = 'There are no tickets to create Excel Reports from.';
    public static NOTIMPORTANT = 'Not Important';
    public static NOTPOSTED = 'Not Posted';
    public static NOTPUBLICFOLDEROWNER = 'The registration failed because you are not the owner of this public folder.<BR>The license information could not be saved. To solve this, please ask the owner of this public folder to register!';
    public static NOTSTARTED = 'Not Started';
    public static NOTSUPPORTHTMLAUDIO = 'Your web browser does not support the HTML5 Audio element.';
    public static NOTURGENT = 'Not Urgent';
    public static NOUSER = 'There is no user in the database';
    public static NOV = 'Nov';
    public static NOVEMBER = 'November';
    public static NOWEBCOMPONENTS = 'Unable to start Office Web Components';
    public static NULLVALUE = 'Null value';
    public static NUMBER = 'Number';
    public static NUMBERCHARACTERSORLESS = 'Please enter [NUMBER] characters or less.';
    public static NUMBERING = 'Numbering';
    public static NUMBERITEMSWEREFOUND = '[NUMBER] tickets were found.';
    public static NUMBEROFAPPOINTMENTS = 'Number of Appoinments';
    public static NUMBEROFITEMS = 'Number of items';
    public static NUMBEROFMISTAKES = 'Number of mistakes';
    public static NUMBEROFORGANIZERS = 'Number of Organizers';
    public static NUMBEROFPARTICIPANTS = 'Number of [ATTENDEES]';
    public static NUMBEROFPROJECTS = 'Number of [PROJECT]s';
    public static NUMBEROFPROJECTSPERRESOURCE = 'Number of Bookings per Resource and [PROJECT]';
    public static NUMBEROFRESOURCESPERPROJECT = 'Number of Resources per [PROJECT]';
    public static NUMBEROFSUPPLIES = 'Number of Supplies';
    public static NUMBEROFTASKS = 'Number of tasks';
    public static NUMOFAPPOINTMENTPERORGANIZER = 'Bookings per Organizer';
    public static NUMOFOPENTICKETS = 'Number of open tickets';
    public static NWUNREACHABLE = 'Unable to connect to the [ACCESS_FILE_PATH]. <BR> Please review the network connectivity!';
    public static OCT = 'Oct';
    public static OCTOBER = 'October';
    public static OF = 'of';
    public static OFCOLUMN = 'of Column';
    public static OFFFORROWSANDCOLUMNS = 'Off for rows and columns';
    public static OFFLINE = 'Failed to get values from the Common Settings. Thus only the previously selected tasks and customers are available in the lists to the left.';
    public static OFFLINECUBECREATINGWAIT = 'The offline .cub file is being created. This might take several minutes.';
    public static OFGRANDTOTAL = 'of Grand Total';
    public static OFNUMBERDISPLAYED = '[NUMBER1] of [NUMBER2] displayed.';
    public static OFROW = 'of Row';
    public static OK = 'OK';
    public static OLAPALREADYOPENMSG = 'OLAP Reporting Tool is already open. Please close it and try again.';
    public static OLAPCUBESAVED = 'OLAP .cub file saved successfully';
    public static OLDPRODUCTVERSION = '[PRODUCT] Client cannot be used with an old version of [PRODUCT]. Please ask your [PRODUCT] administrator to upgrade the SharePoint installation to the latest version.';
    public static OLSDK = 'Do you want to install Windows Live ID For Client Applications SDK?';
    public static ONBEHALFCONFIRMATION = 'Are you sure you want to report events of [OWNERNAME]?';
    public static ONEEMAILCONVERTINTOITEM = '1 e-mail found in the [FOLDER] folder has been converted into a list item.';
    public static ONEMERGEDPDF = 'One merged PDF';
    public static ONEORMOREFIELDHAVEINCORRECT = 'One or more fields have incorrect input.';
    public static ONEYEAROLD = '<APP> needs to be upgraded to a newer version. Upgrades are free for <APP> subscribers. Your current version will stop functioning in <DAYS> days.';
    public static ONFORCOLUMNSONLY = 'On for columns only';
    public static ONFORROWSANDCOLUMNS = 'On for rows and columns';
    public static ONFORROWSONLY = 'On for rows only';
    public static ONHOLD = 'On Hold';
    public static ONLINEINVALIDPATH = 'The Folder HelpDesk online form does not exist in the specified web folder path!<BR>Please consult your administrator/public folder owner to correct this.';
    public static ONLINESTORE = 'Online Store';
    public static ONLINETICKETSCREATED = '# tickets created from XXX!';
    public static ONLYCALLERTICKETS = 'Only Caller tickets';
    public static ONLYFILESAREALLOWED = 'Only JPEG, JPG, PNG, GIF, TIF and TIFF file extensions are allowed.';
    public static ONLYFUTUREAPPOINTMENTS = 'Load only future events in the Overview';
    public static ONLYNUMERIC = 'Please enter only positive numeric values.';
    public static ONLYPDFALLOWED = 'Only PDF files can be added';
    public static ONLYSHOWFREE = 'Only show free';
    public static ONLYSTUDENTCANDODOCEXERCISES = '"Work with document" can only be performed with Student accounts.';
    public static ONQUICKLAUNCH = 'On Quick Launch';
    public static OPACITY = 'Opacity:';
    public static OPEN = 'Open';
    public static OPENBOOKING = 'Open booking';
    public static OPENCONVERTEDTASK = 'Open converted task';
    public static OPENCORRESPONDINGTASK = 'Open corresponding task';
    public static OPENDOCUMENT = 'Open document';
    public static OPENEDTICKET = 'Opened';
    public static OPENEXPORTEDITEM = '[APP] exported successfully. Do you want to open it?';
    public static OPENFILTER = 'Open filter';
    public static OPENINDESKTOPAPP = 'Open in desktop application';
    public static OPENINGEXCELREPORT = 'Opening existing Excel Report';
    public static OPENINGEXISTINGREPORT = 'Opening existing Excel reports';
    public static OPENINGFILE = 'Opening file';
    public static OPENINGLASTSAVEDVIEW = 'Opening last saved view.';
    public static OPENTICKET = 'Open ticket';
    public static OPENTICKETTT = 'Open the Folder HelpDesk Ticket associated with this e-mail.';
    public static OPENVIEW = 'Open view';
    public static OPTIONAL = 'Optional';
    public static OPTIONS = 'Options';
    public static OQYFILESAVED = 'The Excel .oqy file saved successfully';
    public static OR = 'Or';
    public static ORDER = 'Order';
    public static ORDERCOMMENT = 'Comment to order';
    public static ORDERFROM = 'Order from www.kalmstrom.com';
    public static ORDERITEM = 'Order Item';
    public static ORDERS = 'Orders';
    public static ORDERSREPORTVIEWNAME = 'Orders Report';
    public static ORGANIZATION = 'Organization';
    public static ORGANIZER = 'Organizer';
    public static ORGANIZERPERBOOKEDRESOURCE = 'Number of Organizers per Resource';
    public static ORGANIZERTT = 'Indicates who made this reservation';
    public static ORIGINALMESSAGE = 'Original message';
    public static OTHER = 'Other';
    public static OTHEROPTIONS = 'Other Options';
    public static OTHERSETTINGS = 'Other Settings';
    public static OUTOFOFFICE = 'Out of office';
    public static OUTPUTFORMAT = 'Output format:';
    public static OUTPUTOPTIONS = 'Extra options';
    public static OVERDUE = 'Overdue';
    public static OVERDUESTATUS = 'Overdue status of Tasks per Phase';
    public static OVERDUESTATUSPERLANE = 'Overdue status of Tasks per Lane';
    public static OVERVIEW = 'Overview';
    public static OVERVIEWAUTOUPDATINGINTERVAL = 'Auto-update data in CB Overview (mins)';
    public static OVERVIEWFORM = 'Calendar Browser Overview';
    public static OVERWRITEFILES = 'Overwrite files';
    public static PAGEOF = 'Page [X1] of [X2]';
    public static PAGEOFPAGES = 'page / pages';
    public static PAGES = 'Pages';
    public static PART = 'Part';
    public static PARTCOLUMNCOURSEDESCRIPTION = 'Select what course this part should belong to.';
    public static PARTCOLUMNSEQUENCEDESCRIPTION = 'Specify the order of this part in relation to other parts.';
    public static PARTS = 'Parts';
    public static PASSWORD = 'Password';
    public static PASSWORDCHARACTERLENGTH = '1. At least 8 characters long';
    public static PASSWORDCOMBINES = '2. Combines letters, numbers, and symbols';
    public static PASSWORDCONTAININTEGER = 'Please enter at least one numeric digit in the password';
    public static PASSWORDCONTAINSPECIALSYMBOLS = 'Please enter at least one special symbol in the password';
    public static PASSWORDCONTAINUPPERCASE = 'Please enter at least one upper case letter in the password';
    public static PASSWORDHELP = 'Recipients will need this password to open the PDF.';
    public static PASSWORDLENGTH = 'Please enter a password that is 8 characters long';
    public static PASSWORDPLACEHOLDER = 'Leave empty for no password';
    public static PASSWORDPROTECTION = 'Password protection (optional):';
    public static PASTE = 'Paste';
    public static PATH = 'Path';
    public static PATHTOONLINEFORM = 'Path to the Folder HelpDesk Online Form';
    public static PATTERN = 'Pattern';
    public static PAUSE = 'Pause';
    public static PDFSADDED = '[N] PDF(s) added';
    public static PDFSAVED = 'PDF Saved';
    public static PENDING = 'Pending';
    public static PERCENTAGELOWERBOUND = '80% lower bound';
    public static PERCENTAGEUPPERBOUND = '80% upper bound';
    public static PERDIEM = 'Per Diem';
    public static PERMISSION = 'You must have Write permission to add a new article.';
    public static PERMISSIONPUBLICFOLDER = 'You don^t have permission to create a new public folder calendar. Please get at least editor permission and try again.';
    public static PERMISSIONTOADDDELETEVIEWSTUDENTS = 'You do not have permission to add/delete/view students.';
    public static PERMISSIONTOUSEPRODUCT = 'You don^t have permission to use [PRODUCT].<BR>Please ask the [PRODUCT] Administrator to add you.';
    public static PERSON = 'Person';
    public static PERSONALCOPY = 'Create copy of new events in personal calendar';
    public static PERSONALSETTINGS = 'Personal Settings';
    public static PHASE = 'Phase';
    public static PHASEALREADYEXSIST = 'This phase name already exists.';
    public static PHASECANNOTHAVEBLANK = 'Phase cannot have a blank value.';
    public static PHASECAPTION = 'Phase caption';
    public static PHASECHANGED = 'Phase changed';
    public static PHASECOLOR = 'Phase Color';
    public static PHASECONFIGURE = 'Configure Phases';
    public static PHASEDESCRIPTION = 'Phase Description';
    public static PHASELISTFORKTM = 'Phase list for KTM';
    public static PHASENAME = 'Phase Name';
    public static PHASENAMECANNOTEMPTY = 'Phase name can not be empty. Please enter a phase name.';
    public static PHASEORDER = 'Phase order';
    public static PHASES = 'Phases';
    public static PHONE = 'Phone';
    public static PICKADATE = 'Pick a date';
    public static PICKCALLER = 'Picks a user from the Address Book';
    public static PICKFOLDER = 'Pick folder';
    public static PICKFROMADDRESSBOOK = 'Pick from Address Book';
    public static PICTURE = 'Picture';
    public static PIE = 'Pie';
    public static PIV_ADD_CONDITION = 'Add condition';
    public static PIV_ADDCALCULATEDMEASURE = ' Add calculated value';
    public static PIV_ADDGROUP = ' Add group';
    public static PIV_ALIGN_LEFT = 'left';
    public static PIV_ALIGN_RIGHT = 'right';
    public static PIV_ALL = ' All';
    public static PIV_ALL_VALUES = 'All values';
    public static PIV_ALLFIELDS = ' All Fields';
    public static PIV_ALLVALUES = 'All values';
    public static PIV_AMOUNTFOUND = ' {0} of {1} found are selected';
    public static PIV_AMOUNTSELECTED = ' {0} of {1} selected';
    public static PIV_ANALYZING = 'Analyzing data...';
    public static PIV_ANALYZINGPROGRESS = '{0} records of {1} ({2}%)';
    public static PIV_ANALYZINGRECORDS = '{0}% records';
    public static PIV_AND = 'and';
    public static PIV_APPLY = 'Apply';
    public static PIV_APRIL = 'April';
    public static PIV_ASCSORT = ' Az';
    public static PIV_AUGUST = 'August';
    public static PIV_BETWEEN = 'Between';
    public static PIV_BLANKMEMBER = '(blank)';
    public static PIV_BOTTOM = ' Bottom';
    public static PIV_BROWSE = 'Browse';
    public static PIV_CALCULATEINDIVIDUALVALUES = 'Calculate individual values';
    public static PIV_CANCEL = 'Cancel';
    public static PIV_CANTEXPAND = 'Some fields cannot be expanded. Please narrow down the data set.';
    public static PIV_CANTEXPANDTITLE = 'Data set is too large';
    public static PIV_CANTSAVEFILE = 'Cannot save file.';
    public static PIV_CANTSAVETOCLIPBOARD = 'Error';
    public static PIV_CAPTION = 'Sum';
    public static PIV_CHOOSE_PAGE_ORIENTATION = 'Choose page orientation';
    public static PIV_CHOOSE_VALUE = 'Choose value';
    public static PIV_CLASSIC_VIEW = 'Classic form';
    public static PIV_CLEAR = 'Clear';
    public static PIV_CLEARSORTING = 'Clear sorting';
    public static PIV_CLEARTOPX = ' Clear';
    public static PIV_CLOSE = 'Click to close';
    public static PIV_COLLAPSE = 'Collapse';
    public static PIV_COLLAPSEALL = ' Collapse All';
    public static PIV_COLLAPSEICON = 'Click to collapse';
    public static PIV_COLUMN = 'Column';
    public static PIV_COLUMNBOX = ' Drop & Arrange Columns';
    public static PIV_COLUMNS = ' Columns';
    public static PIV_COMPACT_VIEW = 'Compact form';
    public static PIV_CONDITIONAL = 'Conditional';
    public static PIV_CONDITIONAL_FORMATTING = 'Conditional formatting';
    public static PIV_CONDITIONAL_FORMATTING_MOBILE = 'Conditional';
    public static PIV_CONFIRMATION = 'Confirmation';
    public static PIV_CONNECT = 'Connect';
    public static PIV_CONNECT_LOCAL_CSV = 'To local CSV';
    public static PIV_CONNECT_LOCAL_JSON = 'To local JSON';
    public static PIV_CONNECT_LOCAL_OCSV = 'To local OCSV';
    public static PIV_CONNECT_REMOTE_CSV = 'To remote CSV';
    public static PIV_CONNECT_REMOTE_CSV_MOBILE = 'CSV';
    public static PIV_CONNECT_REMOTE_JSON = 'To remote JSON';
    public static PIV_CONNECT_REMOTE_JSON_MOBILE = 'JSON';
    public static PIV_CP_HIGHLIGHT = 'Highlight';
    public static PIV_CP_TEXT = 'Text';
    public static PIV_CSV = 'CSV';
    public static PIV_CSVHEADERPARSINGERROR = 'CSV header parsing error.';
    public static PIV_CURRENCY_ALIGN = 'Currency align';
    public static PIV_CURRENCY_SYMBOL = 'Currency symbol';
    public static PIV_DATAWASUPDATED = 'Data source has been updated on the server. Refresh the report?';
    public static PIV_DATEINVALIDCAPTION = 'Invalid date';
    public static PIV_DAY = 'Day';
    public static PIV_DECEMBER = 'December';
    public static PIV_DECIMAL_PLACES = 'Decimal places';
    public static PIV_DECIMAL_SEPARATOR = 'Decimal separator';
    public static PIV_DELETE = 'Delete';
    public static PIV_DESCSORT = ' zA';
    public static PIV_DONE = 'Done';
    public static PIV_DRILLDOWN = 'Click to drill down';
    public static PIV_DRILLTHROUGH = 'Drill through';
    public static PIV_DRILLUP = 'Click to drill up';
    public static PIV_DROPFIELD = ' Drop field here';
    public static PIV_EQUAL_TO = 'Equal to';
    public static PIV_ERROR = 'Error!';
    public static PIV_EXCELCSVCHARTSEXPORTERROR = 'Export to Microsoft Excel or CSV is not available for charts.';
    public static PIV_EXCELEXPORTLIMITATION = 'Export is not available in the current edition.';
    public static PIV_EXCELPDFEXPORTLIMITATION = 'Export to Microsoft Excel or PDF is not available in the current edition.';
    public static PIV_EXPAND = 'Expand';
    public static PIV_EXPANDALL = ' Expand All';
    public static PIV_EXPANDICON = 'Click to expand';
    public static PIV_EXPORT = 'Export';
    public static PIV_EXPORT_EXCEL = 'To Excel';
    public static PIV_EXPORT_HTML = 'To HTML';
    public static PIV_EXPORT_PDF = 'To PDF';
    public static PIV_EXPORT_PRINT = 'Print';
    public static PIV_EXPORTCOMPLETE = 'Export data is created, please click \Save\ button to save the _data.';
    public static PIV_EXPORTERROR = 'Failed to export. An unexpected error occurred.';
    public static PIV_EXPORTPROGRESS = 'Export in progress...';
    public static PIV_FALSE_VALUE = 'false';
    public static PIV_FEBRUARY = 'February';
    public static PIV_FIELDS = 'Fields';
    public static PIV_FIFTH = 'Thursday';
    public static PIV_FILTERBOX = ' Drop & Arrange Report Filter';
    public static PIV_FILTERED = 'Filtered';
    public static PIV_FILTERICON = 'Click to filter';
    public static PIV_FILTERS = ' Report Filters';
    public static PIV_FIRST = 'Sunday';
    public static PIV_FLAT_VIEW = 'Flat form';
    public static PIV_FLATHIERARCHYBOX = ' Select and arrange columns';
    public static PIV_FORMAT = 'Format';
    public static PIV_FORMAT_CELLS = 'Format cells';
    public static PIV_FORMAT_CELLS_MOBILE = 'Format';
    public static PIV_FORMULA = 'Formula';
    public static PIV_FORMULAPROMPT = 'Drop values and edit formula here';
    public static PIV_FORMULASGROUPNAME = ' Calculated Values';
    public static PIV_FOURTH = 'Wednesday';
    public static PIV_FULLSCREEN = 'Open report in full screen?';
    public static PIV_GENERATINGPDF = 'Generating PDF';
    public static PIV_GRAND_TOTALS = 'Grand totals';
    public static PIV_GRAND_TOTALS_OFF = 'Do not show grand totals';
    public static PIV_GRAND_TOTALS_ON = 'Show grand totals';
    public static PIV_GRAND_TOTALS_ON_COLUMNS = 'Show for columns only';
    public static PIV_GRAND_TOTALS_ON_ROWS = 'Show for rows only';
    public static PIV_GRANDTOTAL = 'Grand Total';
    public static PIV_GRANDTOTALCAPTION = 'Total Sum of {0}';
    public static PIV_GREATER_THAN = 'Greater than';
    public static PIV_GREATER_THAN_OR_EQUAL = 'Greater than or equal to';
    public static PIV_GRID = 'Grid';
    public static PIV_GRID_CLASSIC = 'Classic';
    public static PIV_GRID_COMPACT = 'Compact';
    public static PIV_GRID_FLAT = 'Flat';
    public static PIV_GROUPNAME = ' Group 1';
    public static PIV_HEADER = 'Add calculated value';
    public static PIV_HEADERFIT = 'Double click to fit';
    public static PIV_HEADERRESIZE = 'Drag to resize';
    public static PIV_HIERARCHYBOX = ' Drag Dimensions';
    public static PIV_IF = 'If';
    public static PIV_INAPPROPRIATEFILEFORMAT = 'The data file is of inappropriate format.';
    public static PIV_INPUTNEWNAME = 'Input new name';
    public static PIV_INPUTREPORTNAME = 'Please input report name';
    public static PIV_INVALIDJSONDATA = 'JSON data is invalid.';
    public static PIV_INVALIDREPORTFORMAT = 'Invalid report format or access to file is denied.';
    public static PIV_IS_EMPTY = 'Empty';
    public static PIV_IS_PERCENT = 'Format as percent';
    public static PIV_JANUARY = 'January';
    public static PIV_JULY = 'July';
    public static PIV_JUNE = 'June';
    public static PIV_LANDSCAPE = 'Landscape';
    public static PIV_LAYOUT = 'Layout';
    public static PIV_LAYOUT_OPTIONS = 'Layout options';
    public static PIV_LESS_THAN = 'Less than';
    public static PIV_LESS_THAN_OR_EQUAL = 'Less than or equal to';
    public static PIV_LIMITATION = 'Limitation!';
    public static PIV_LOAD_JSON = 'JSON report';
    public static PIV_LOADING = 'Loading...';
    public static PIV_LOADINGDATA = 'Loading data...';
    public static PIV_LOADINGDIMENSIONS = 'Loading dimensions...';
    public static PIV_LOADINGHIERARCHIES = 'Loading hierarchies...';
    public static PIV_LOADINGKPIS = 'Loading KPIs...';
    public static PIV_LOADINGLEVELS = 'Loading levels...';
    public static PIV_LOADINGMEASURES = 'Loading measures...';
    public static PIV_LOADINGMEMBERS = 'Loading members...';
    public static PIV_LOADINGPROPERTIES = 'Loading properties...';
    public static PIV_LOADREPORTFROMFILE = 'Select report file to be loaded.';
    public static PIV_LOCAL_REPORT = 'Local report';
    public static PIV_MARCH = 'March';
    public static PIV_MAY = 'May';
    public static PIV_MEASUREBOX = ' Drop & Arrange Values';
    public static PIV_MEASURENAME = 'Value name';
    public static PIV_MEASURESPROMPT = ' Choose value';
    public static PIV_MINIMIZE = 'Minimize';
    public static PIV_MONTH = 'Month';
    public static PIV_MULTIPLEITEMS = ' Multiple Items';
    public static PIV_NO = 'No';
    public static PIV_NODATAAVAILABLE = 'Data source is empty. Please check the CSV file.';
    public static PIV_NONE = 'None';
    public static PIV_NOT_EQUAL_TO = 'Not equal to';
    public static PIV_NOVEMBER = 'November';
    public static PIV_NULL_VALUE = 'Null value';
    public static PIV_OCSVINCOMPATIBLE = 'Unable to read data source. It seems that OCSV file was compressed with a newer version. Please update the component to version {0} or newer.';
    public static PIV_OCTOBER = 'October';
    public static PIV_OK = 'OK';
    public static PIV_OPEN = 'Open';
    public static PIV_OPEN_REMOTE_CSV = 'Open remote CSV';
    public static PIV_OPEN_REMOTE_JSON = 'Open remote JSON';
    public static PIV_OPEN_REMOTE_REPORT = 'Open remote report';
    public static PIV_OPENFILTER = 'Open filter';
    public static PIV_OPTIONS = 'Options';
    public static PIV_PAGESWEREGENERATED = 'pages were generated.';
    public static PIV_PLEASEWAIT = 'Please wait.';
    public static PIV_PORTRAIT = 'Portrait';
    public static PIV_PROGRESS = '{0}K';
    public static PIV_PROGRESSUNKNOWN = 'loaded {0}K';
    public static PIV_Q1 = 'Quarter 1';
    public static PIV_Q2 = 'Quarter 2';
    public static PIV_Q3 = 'Quarter 3';
    public static PIV_Q4 = 'Quarter 4';
    public static PIV_QUARTER = 'Quarter';
    public static PIV_REMOTE_REPORT = 'Remote report';
    public static PIV_REMOTE_REPORT_MOBILE = 'Report';
    public static PIV_REMOVEVALUE = 'Remove';
    public static PIV_REMOVEVALUEMESSAGE = 'Are you sure you want to remove this calculated value?';
    public static PIV_REMOVEVALUETITLE = 'Remove {0}?';
    public static PIV_REPORTFILETYPE = 'Flexmonster report file';
    public static PIV_REPORTINFORMATION = 'Report Information';
    public static PIV_ROW = 'Row';
    public static PIV_ROWBOX = ' Drop & Arrange Rows';
    public static PIV_ROWS = ' Rows';
    public static PIV_SAVE = 'Save';
    public static PIV_SAVE_JSON = 'null,';
    public static PIV_SAVEDATATOFILE = 'Data is ready to be saved to file, please click \Save\ button to save the file.';
    public static PIV_SAVEREPORTTOFILE = 'Report is ready to be saved to file, please click \Save\ button to save the report.';
    public static PIV_SAVING = 'Saving...';
    public static PIV_SEARCH = ' Search';
    public static PIV_SECOND = 'Monday';
    public static PIV_SELECT = 'Select';
    public static PIV_SELECTALL = ' Select All';
    public static PIV_SELECTALLRESULTS = ' Select All Results';
    public static PIV_SEPTEMBER = 'September';
    public static PIV_SEVENTH = 'Saturday';
    public static PIV_SIXTH = 'Friday';
    public static PIV_SORT = ' Sort';
    public static PIV_SORTCOLUMNASC = 'Sort column asc';
    public static PIV_SORTCOLUMNDESC = 'Sort column desc';
    public static PIV_SORTEDASCICON = 'Click to sort Desc';
    public static PIV_SORTEDDESCICON = 'Click to sort Asc';
    public static PIV_SORTICON = 'Click to sort Desc';
    public static PIV_SORTROWASC = 'Sort row asc';
    public static PIV_SORTROWDESC = 'Sort row desc';
    public static PIV_SPACE = '(Space)';
    public static PIV_SUBTITLE = ' Drag and drop fields to arrange';
    public static PIV_SUBTOTALS = 'Subtotals';
    public static PIV_SUBTOTALS_OFF = 'Do not show subtotals';
    public static PIV_SUBTOTALS_ON = 'Show subtotals';
    public static PIV_SUBTOTALS_ON_COLUMNS = 'Show subtotal columns only';
    public static PIV_SUBTOTALS_ON_ROWS = 'Show subtotal rows only';
    public static PIV_TEXT_ALIGN = 'Text align';
    public static PIV_THEN = 'Then';
    public static PIV_THIRD = 'Tuesday';
    public static PIV_THOUSAND_SEPARATOR = 'Thousand separator';
    public static PIV_TITLE = ' Fields';
    public static PIV_TOOMANYCOLUMNSINCLASSICMODE = 'Too many columns for classic form. Switched layout to compact form.';
    public static PIV_TOP = ' Top';
    public static PIV_TOPX = ' Top 10';
    public static PIV_TOTAL = 'Total';
    public static PIV_TOTALCAPTION = 'Sum of {0}';
    public static PIV_TOTALS = 'Totals';
    public static PIV_TRUE_VALUE = 'true';
    public static PIV_UNABLETWOFILEBROWSINGSESSIONS = 'Browse file dialog is already opened.';
    public static PIV_UNGROUP = 'Ungroup';
    public static PIV_UNKNOWNERROR = 'Unknown error occurred.';
    public static PIV_UPLOADING = 'Uploading...';
    public static PIV_VALUE = '{0}';
    public static PIV_VALUES = ' Values';
    public static PIV_WAITING = 'Waiting for the response {0} sec.';
    public static PIV_WARNING = 'Warning!';
    public static PIV_WRONGFORMULAFORMAT = 'Wrong formula format. Please check.';
    public static PIV_YEAR = 'Year';
    public static PIV_YES = 'Yes';
    public static PIVOT = 'Pivot';
    public static PLACEHOLDERREMOVE = 'You cannot remove the placeholder variable [DESCRIPTION]!';
    public static PLACESETTINGS = 'Place Settings';
    public static PLAINTEXT = 'Plain text';
    public static PLAINTEXTTITLE = 'Send outgoing e-mail as plain text';
    public static PLEASEENTERONLYNUMERICVALUE = 'Please enter only a whole, positive number between 1 and 10000';
    public static PLEASEINSERTDATAFIRST = 'Please create some tasks before opening OLAP Reporting Tool';
    public static PLEASESELECTAVALIDEMAIL = 'Please select an e-mail item.';
    public static PLEASETRYAGAIN = 'Please try again.';
    public static PLEASEWAIT = 'Processing, please wait...';
    public static PLEASEWAITEXMDATALOADING = '[PRODUCT] example data is loading, please wait...';
    public static PLEASEWAITSYNCHRONIZINGALLTASKS = 'Synchronizing all items, please wait...';
    public static POLARAREA = 'Polar Area';
    public static POPULATECALLERSTOBCC = 'Populate the selected callers to the BCC field of a new e-mail';
    public static POPULATENOW = 'Populate now';
    public static PORTRAIT = 'Portrait';
    public static POSITION = 'Position:';
    public static POSTED = 'Posted';
    public static POWERPOINTDOCUMENT = 'PowerPoint Presentation';
    public static PREDEFINED = 'Predefined';
    public static PREFIXSUBJECT = 'Prefix subject';
    public static PREFIXTT = 'Indicates that the original subject line should be used with this subject line as a prefix.';
    public static PREPARINGTODISPLAYDATA = 'Preparing to display data, please wait...';
    public static PREVENTRECURRING = 'Prevent recurring';
    public static PREVIEWHELP = 'Review each PDF before saving or downloading.';
    public static PREVIEWPAGE = 'Ticket preview page';
    public static PREVIEWRESULTS = 'Preview results';
    public static PREVIOUS = 'Previous';
    public static PREVIOUSAPPOINTMENT = 'Previous Event';
    public static PRINT = 'Print';
    public static PRINTMULTIPLIETICKETSFORM = 'Print multiple tickets';
    public static PRINTOVERVIEW = 'Prints the current view';
    public static PRINTSHORTCUT = 'Please open the item and try with the shortcut keys Ctrl + Shift + P.';
    public static PRINTTT = 'Prints this ticket';
    public static PRIORITY = 'Priority';
    public static PRIVATE = 'Private';
    public static PROBLEM = 'Incident';
    public static PROBLEMCATEGORY = 'Incident Category';
    public static PROBLEMEXCELCATEGORY = 'Problem Category';
    public static PROBLEMEXCELTYPE = 'Problem Type';
    public static PROBLEMINADDINGWEBPART = 'Problem in adding the "Course contents" web part. Please add it [manually].';
    public static PROBLEMTYPE = 'Incident Type';
    public static PROBLEMTYPENOTSAVED = 'The ticket cannot been closed if the Incident Type is not saved in the database. Do you want to save the Incident Type in the database and close the ticket?';
    public static PROCESSMAILTOTICKET = 'Folder HelpDesk E-mail Processing';
    public static PRODUCT = 'Product';
    public static PRODUCTARCHIVE = '[PRODUCT] Archive';
    public static PRODUCTCATEGORY = '[PRODUCT] Categories';
    public static PRODUCTCONFIGURATION = '[PRODUCT] Configuration';
    public static PRODUCTDOESNOTWORKINMODERNWEBPARTS = '[PRODUCT] does not work in modern web parts.';
    public static PRODUCTHASBEENDEACTIVATED = 'Either the site [SITE URL] has been deleted or [PRODUCT] is deactivated.';
    public static PRODUCTISCREATINGCONTENTTYPES = 'Please be patient. [PRODUCT] is creating content types...';
    public static PRODUCTISCREATINGLIST = '[PRODUCT] is creating list, please wait...';
    public static PRODUCTISCREATINGLISTS = 'Please be patient. [PRODUCT] is creating lists...';
    public static PRODUCTISCREATINGSITECOLUMNS = 'Please be patient. [PRODUCT] is creating site columns...';
    public static PRODUCTISDELETINGLIST = '[PRODUCT] is deleting list, please wait...';
    public static PRODUCTISVALIDATINGLISTCONTENTTYPES = 'Please be patient. [PRODUCT] is validating list content types...';
    public static PRODUCTLISTS = '[PRODUCT] Lists';
    public static PRODUCTSETTINGS = '[PRODUCT] Settings';
    public static PRODUCTSTATEFORREGISTER = '[PRODUCT] is [STATE]. Please ask your site administrator to register [PRODUCT].';
    public static PRODUCTUSERS = '[PRODUCT] Users';
    public static PRODUCTVIEW = '[PRODUCT] View';
    public static PRODUCTWELCOME = 'Welcome to [PRODUCT]';
    public static PROGRESS = 'Progress';
    public static PROGRESSREPORT = 'Progress Report';
    public static PROJECT = 'Project';
    public static PROJECTBOOKEDPERORGANIZER = 'Number of Bookings per Organizer and [PROJECT]';
    public static PROJECTCANNOTHAVEBLANK = 'Project cannot have a blank value.';
    public static PROJECTDESCRIPTION = 'Project Description';
    public static PROJECTFORTASKCOLOR = 'Use colors for [PROJECTS]';
    public static PROJECTLISTFORKTM = 'Project list for KTM';
    public static PROJECTNAME = 'Project Name';
    public static PROJECTS = 'Projects';
    public static PROJECTVIEW = 'Project View';
    public static PRONOTAVIALBLE = 'Click OK to save your changes. When you open the settings again, this link will work.';
    public static PROVIDEVALIDEMAILADDRESS = 'Please enter a valid e-mail address.';
    public static PROXYSETTINGS = 'Proxy settings';
    public static PTINTERFACENOTDISPLAYED = 'The Pivot Table interface could not be displayed';
    public static PTRESULTNOTDISPLAYED = 'The Pivot Table results could not be displayed';
    public static PUBLICFOLDER = 'Public folder';
    public static PUBLISH = 'Publish';
    public static PUBLISHASWEBPAGES = 'Publish to Web Pages';
    public static PUBLISHCHANGES = 'Publish changes';
    public static PUBLISHERSELECTOR = '[PRODUCT] Publisher Selector';
    public static PUBLISHING = 'Publishing...';
    public static PUBLISHTEMPLATES = 'Publish Templates';
    public static PURCHASEFROMWWWKALMSTROMNU = 'Purchase an organizational license for this product directly from www.kalmstrom.com';
    public static QUANTITY = 'Quantity';
    public static QUARTER = 'Quarter';
    public static QUARTERS = 'Quarters';
    public static QUESTION = 'Question ';
    public static RADAR = 'Radar';
    public static RANDOMIZETASKS = 'Randomize tasks';
    public static RATE = 'Rate';
    public static RATESAREDEFINEDBY = 'Rates are defined by';
    public static READINGAPP = 'Reading events of the calendar [CALENDAR], please wait...';
    public static READINGDATA = 'Reading data';
    public static READINGDATAFROMCALNDARS = 'Reading data from calendars, please wait...';
    public static READINGLISTDATA = 'Reading list data, please wait...';
    public static READONLYMSG = 'This ticket is already opened by another user. Therefore the ticket will open in read only mode, and your changes to the ticket will not be saved.';
    public static READRECEIPT = 'Read receipt';
    public static READRECEIPTTT = 'Request a read report for the outgoing e-mail.';
    public static READSETTINGS = 'Reading settings from [PRODUCT]';
    public static REALLYREMOVE = 'Are you sure you want to remove this calendar?';
    public static RECEIVED = 'Recieved';
    public static RECEIVEDEMAILS = 'Received E-mails';
    public static RECIPENTS = 'Recipients';
    public static RECURRING = 'Recurring';
    public static RECURRINGPREVENTMESSAGE = 'Recurring events are not allowed in this calendar.';
    public static RECURRINGREGCHECKNOTICE1 = 'In [DAYS] days [PRODUCT] will automatically verify that your registration key is still valid. No private information will be collected.';
    public static RECURRINGREGCHECKNOTICE2 = 'The key will continue to work as long as your organization is a Member of the kalmstrom.com Community.';
    public static RECURRINGREGCHECKNOTICE3 = 'A Community Membership gives the right to use any software from kalmstrom.com Business Solutions, with full support and free  upgrades.';
    public static REDINGRATE = 'Reading rate:';
    public static REDO = 'Redo';
    public static REFRESH = 'Refresh';
    public static REFRESHING = 'Refreshing tables and charts';
    public static REFRESHPAGE = 'Click here to refresh the page!';
    public static REG1 = 'This is an unregistered version of';
    public static REG2 = 'Please purchase the registered version at www.kalmstrom.com';
    public static REGCODE = 'Registration code';
    public static REGEMAIL = 'Enter the e-mail address below and press Registration. You must be connected to the internet for the registration to work.';
    public static REGEXPIRE = 'Your registration has expired. Do you want to register?';
    public static REGION = 'Region';
    public static REGISTEREDVERSION = 'You have now a registered version of [PRODUCT].';
    public static REGISTRATION = 'Registration';
    public static REGISTRATIONFAILED = 'Registration failed!';
    public static REGISTRATIONINFO = 'Registration Info';
    public static REGISTRATIONLISTFORKTM = 'Registration list for KTM';
    public static REGISTRATIONPLEASEWAIT = 'Contacting server for authentication, please wait...';
    public static REGISTRATIONSERIALNO = 'Registration Serial No';
    public static REGISTRATIONSUCCEEDED = 'Registration succeeded!';
    public static REGLINK = 'Your [PRODUCT] has expired. To register';
    public static REGNAG1 = 'This is a fully functional unregistered version of " & TOOLBARNAME & vbCrLf & "';
    public static REGNOW = 'Would you like to register now?';
    public static REMEMBERLOGININFO = 'Remember login info';
    public static REMEMBEROPTION = 'Remember this option next time';
    public static REMOVE = 'Remove';
    public static REMOVEATTACHMENT = 'Do you want to remove the attachment?';
    public static REMOVEEMAIL = 'Delete mail';
    public static REMOVEFORMATTING = 'Remove Formatting';
    public static REMOVEITEM = 'Remove item';
    public static REMOVELUNCH = 'Remove lunch time from events longer than 7 hours';
    public static REMOVEOLDMEETINGS = 'Would you like to remove all events that have  occurred up until the chosen month and move them to the database?';
    public static REMOVEREPORT = 'Remove report';
    public static REMOVEREPORTS = 'Remove time reports';
    public static REMOVESITEFROMPRODUCT = 'Are you sure you want to remove this site and its lists from [PRODUCT]?';
    public static REMOVESITEFROMPROJECT = 'Are you sure you want to remove this site from [PRODUCT]?';
    public static REMOVESTUDENT = 'Remove Student';
    public static REMOVESTUDYGROUP = 'Remove Study Group';
    public static REMOVETICKETLIST = 'Remove SharePoint list';
    public static REMOVETITLE = 'Delete the selected template';
    public static RENDERERROR = 'An error occurred rendering the Pivot Table results.';
    public static RENEW = 'Renew';
    public static REOPEN = 'Reopen';
    public static REOPRTBEHALF = 'Reporting on behalf of';
    public static REPASSWORD = 'Retype password';
    public static REPEATING = 'Make this a repeating event.';
    public static REPLACENULLWITH = 'Replace null with';
    public static REPLYNOTIFICATION = 'Automatic e-mail to Responsible on reply received';
    public static REPORT = 'Report';
    public static REPORTCATEGORY = 'Report category';
    public static REPORTCOSTPERTAG = 'Costs per [TAG]';
    public static REPORTCOUNTPERTAG = 'Number of events per [TAG]';
    public static REPORTDATE = 'Report date';
    public static REPORTEDEVENTS = 'Reported Events';
    public static REPORTEXPENSESPERTAG = 'Expenses per [TAG]';
    public static REPORTFORNAME = 'Reports for [NAME]';
    public static REPORTHOURSPERTAG = 'Hours per [TAG]';
    public static REPORTINGDONE = 'Reporting for this period done!';
    public static REPORTINGINPROGRESS = 'Reporting is in progress, please wait...';
    public static REPORTLISTDESCRIPTION = 'Report list to store student progress summary.';
    public static REPORTMETA = 'When exporting to [REPORT], group data by';
    public static REPORTNAME = 'Report name';
    public static REPORTOPENHOURSPERTAG = 'Hours Open per [TAG]';
    public static REPORTS = 'Reports';
    public static REPORTTO = 'Report To';
    public static REPORTTOACCESS = 'Report to Access';
    public static REPORTTOASP = 'Report to ASP-page';
    public static REPORTTOEMAIL = 'Report via e-mail';
    public static REPORTTOSQL = 'Report to MS SQL Server';
    public static REPORTTT = 'Reports your events';
    public static REPORTTYPE = 'Report type';
    public static REQUESTFAILED = 'Request failed:';
    public static REQUIRDFIELDINFO = 'You must specify a value for this required field.';
    public static REQUIREPROJ = '[PROJECT] mandatory';
    public static RESERVATIONSUMMARIES = 'Booking Summaries';
    public static RESET = 'Reset';
    public static RESETFILTER = 'Reset filter';
    public static RESETKBASEPATHCONFIRMATION = 'Are you sure you want to remove the existing KBase path?';
    public static RESIZEDROPDOWNFIELDS = 'Resize drop-down fields to available space';
    public static RESOLVERESPONSIBLE = 'Resolve Responsible';
    public static RESOLVETAG = 'Resolve [PRODUCT] Tag';
    public static RESOURCE = 'Resource';
    public static RESOURCEBOOKEDPERORGNIZER = 'Booked Resources per Organizer';
    public static RESOURCEBOOKEDPERYEAR = 'Number of Resources per Year';
    public static RESOURCECOST = 'Resource Cost';
    public static RESOURCENAME = 'Resource name';
    public static RESPONSIBLEAVGHOURSOPEN = 'Average ticket time per Responsible';
    public static RESPONSIBLECANNOTHAVEBLANK = 'Responsible cannot have a blank value.';
    public static RESPONSIBLEDEFAUTLVALUE = 'Not Assigned';
    public static RESPONSIBLEEMAIL = 'Responsible E-mail';
    public static RESPONSIBLEFORTASKCOLOR = 'Use colors for Assigned';
    public static RESPONSIBLEHOURS = 'Sum of hours spent on tickets by each Responsible';
    public static RESPONSIBLELISTFORKTM = 'Responsible list for KTM';
    public static RESPONSIBLENAME = 'Responsible Name';
    public static RESPONSIBLENUMBER = 'Number of tickets per Responsible';
    public static RESPONSIBLERATE = 'Cost per Responsible';
    public static RESPONSIBLES = 'Assigned';
    public static RESULT = 'Result';
    public static RESULTSSUBTITLE = 'Download individually, save all to a library, or download everything at once.';
    public static RESUMEHERE = 'Resume here';
    public static RESUMEKTMBAORD = 'The task has been opened in a new tab.<br>Click on ^Resume here^ when you are done.';
    public static RETRIEVEONLINETICKETS = 'Retrieve online tickets';
    public static RETRIEVEONLINETICKETSTT = 'Retrieve online tickets from web folder';
    public static RETRY = 'Retry';
    public static RETRYFAILED = 'Retry failed — file could not be converted';
    public static RETYPEPASSWORDANDPASSWORDNOTMATCH = 'Password and Retype password do not match';
    public static RIGHT = 'Right';
    public static RIGHTALTERNATIVES = 'Right alternatives';
    public static RIGHTALTERNATIVESCOLUMNDESCRIPTION = 'Enter the correct alternatives of the right column, one for each row.';
    public static RIGHTARROWKEYPLAYORPAUSE = 'Use the right arrow key or the Play/Pause button to syncronize text with audio as spoken.';
    public static RIGHTCAPTION = 'Right heading';
    public static RIGHTHEADINGCOLOMNDESCRIPTION = 'Enter the heading of the right column.';
    public static RIGHTPART = 'Right part';
    public static RIGHTPARTCOLUMNDESCRIPTION = 'Enter the ends of the sentences, one for each row. They will be shown in a random order.';
    public static RIGTHFOLDERPATH = 'The folder path you have given is not valid.<BR>Please make sure that the path is shorter than 200 characters and does not contain special characters (@, $, #, ~,* ...).';
    public static ROWHEATMAP = 'Heat map Row';
    public static RTF = 'Rich text format';
    public static RUNFROMFILESERVER = 'Run application from the fileserver';
    public static RUNINDEXHTMLWHENDONE = 'Run [INDEXHTML] when done';
    public static SA = 'Sa';
    public static SALES = 'Sales';
    public static SALESPERSON = 'Salesperson';
    public static SAMPLESTANDARDDEVIATION = 'Sample standard deviation';
    public static SAMPLEVARIANCE = 'Sample variance';
    public static SAND = 'Send';
    public static SAT = 'Sat';
    public static SATURDAY = 'Saturday';
    public static SAVE = 'Save';
    public static SAVEALL = '💾 Save all / 💾 Save [N]';
    public static SAVEALLINCLOSEDTICKETS = 'Save all in closed tickets';
    public static SAVECALENDAREINFO = 'Save calendar information';
    public static SAVECHANGES = 'Would you like to save your changes?';
    public static SAVECONFIRMATIONMSG = 'Save before exit?';
    public static SAVECUSTOMFIELDSDESCRIPTION = 'Save the following checked custom fields (introduced in the Folder HelpDesk ticket form) to the database';
    public static SAVEDCONFIRMATION = 'The changes have been saved.';
    public static SAVEEMAILINSUBFOLDERS = 'Save e-mails in subfolders';
    public static SAVEFAQQUESTION = 'Do you want to save the current FAQ?';
    public static SAVEINPROGRESS = 'Saving to the database, please wait...';
    public static SAVEMAILHISTORYINTICKETBODY = 'Save e-mails in ticket body';
    public static SAVENCLOSE = 'Save and close window';
    public static SAVEPICTURE = 'Save picture';
    public static SAVEPROJECTIN = 'Save [PROJECT]s in';
    public static SAVEREPORT = 'Save report';
    public static SAVERESOURCEINFO = 'Save Resource Info';
    public static SAVESENT = 'Save sent';
    public static SAVESENTTT = 'Where the sent e-mail  should be saved. Default is Sent Items!';
    public static SAVESUPPLYLIST = 'Save supply list';
    public static SAVETOLIBRARY = 'Save to library';
    public static SAVETT = 'Closes and saves this  ticket - used when the incident is NOT resolved!';
    public static SAVEYOURPHASENAMESCHANGE = 'Please click OK to save your change. Then enter the phase names under the Phases tab.';
    public static SAVEYOURRESPONSIBLENAMESCHANGE = 'Please click OK to save your change. Then enter the names of the responsible persons under the Responsible tab.';
    public static SAVINGCUSTOMVIEW = 'Saving custom view';
    public static SAVINGSETTINGSPLEASEWAIT = 'Saving settings, please wait...';
    public static SCATTER = 'Scatter';
    public static SEARCH = 'Search';
    public static SEARCHARTICLE = 'Search Article';
    public static SEARCHCALENDARS = 'Search Calendars';
    public static SEARCHCAPTION = 'Folder HelpDesk Open Tickets Search';
    public static SEARCHCLOSEDTICKETS = 'Search closed tickets';
    public static SEARCHEMAILTT = 'Enter performs a search ... CTRL + Enter creates a new e-mail';
    public static SEARCHEVERYWHERE = 'Find this string everywhere';
    public static SEARCHFRAME = 'Select a creation date option to use in searching for closed ticket folders';
    public static SEARCHINGFORTEMPLATELIBS = 'Searching for TMTemplates libraries';
    public static SEARCHINGFORTEMPLATES = 'Searching for templates in [NAME]';
    public static SEARCHRESULT = 'Closed ticket subfolders found';
    public static SEARCHRESULTS = 'Search results';
    public static SEARCHTASKS = 'Search Tasks';
    public static SEARCHTASKTT = 'Enter performs a search ... CTRL + Enter creates a new task';
    public static SEARCHTICKETS = 'Search tickets';
    public static SEARCHTICKETTT = 'Enter performs a search. CTRL + Enter creates a new ticket.';
    public static SEATS = 'Seats';
    public static SECOND = 'Second';
    public static SELECT = 'Select';
    public static SELECTALL = 'Select all';
    public static SELECTANDARRANGECOLUMNS = 'Select and arrange columns';
    public static SELECTAPROBLEMCATEGORY = 'Select an Incident Category';
    public static SELECTASHAREPOINTLIST = 'Please select a SharePoint list where tickets from this folder will be created.';
    public static SELECTASITE = 'Select a site';
    public static SELECTATLEASTONEITEM = 'Please select at least one item. ';
    public static SELECTCALENDAR = 'Please select a calendar first';
    public static SELECTCALENDARS = 'Select calendars';
    public static SELECTCALLERCATEGORY = 'Select a Caller Category';
    public static SELECTCATEGORY = 'Select Category';
    public static SELECTCATEGORYANDTYPES = 'Select categories and types';
    public static SELECTCBINSTALLATION = 'Select CB Group';
    public static SELECTCHAPTER = 'Select Chapter';
    public static SELECTCOURSE = 'Select Course';
    public static SELECTDATERANGE = 'Please choose a date within the selected date range.';
    public static SELECTEXERCISE = 'Select Exercise';
    public static SELECTEXPORTFOLDER = 'Please select a folder to export the selected tickets.';
    public static SELECTEXPORTOPTION = 'Select an export option';
    public static SELECTFAQ = 'Please select a FAQ from the list below:';
    public static SELECTFIELDS = 'Select the SharePoint fields that you want to include in the statistics';
    public static SELECTFIELDSMERGE = 'Select fields to be merged';
    public static SELECTFILTERS = 'Filters';
    public static SELECTFOLDERTOPLACEWEBPAGES = 'Select folder for the web pages';
    public static SELECTION = 'Info about current selection';
    public static SELECTKTMTASKLIST = 'Do you want to use the existing task list [NAME] or create a new list: "KTM Tasks"?';
    public static SELECTLANGUAGE = 'Select language';
    public static SELECTLIST = 'Select List';
    public static SELECTMEASURES = 'Select measures';
    public static SELECTMETA = 'Select tags';
    public static SELECTMORETICKETS = 'Please select more than one ticket to merge';
    public static SELECTNETWORKFOLDER = 'Select a [APP] network folder';
    public static SELECTNONE = 'Select none';
    public static SELECTOQYFILE = 'Choose a .oqy-file created with Excel or MS Query';
    public static SELECTPAGEORIENTATION = 'Select page orientation';
    public static SELECTPARENT = 'Please select a Parent ticket first';
    public static SELECTPARENTTICKET = 'Select Parent ticket';
    public static SELECTPART = 'Select Part';
    public static SELECTPROVIDER = 'Select Provider';
    public static SELECTSHAREPOINTLIST = 'Select a SharePoint list';
    public static SELECTSPFIELDS = 'Select Fields';
    public static SELECTSTUDENT = 'Select Student';
    public static SELECTSTUDYGROUP = 'Select Study Group';
    public static SELECTTASKLIST = 'Select a Tasks List';
    public static SELECTTEMPLATEDESC = 'Select the template you want to use';
    public static SELECTTEMPLATEEDIT = 'Please select a template to edit';
    public static SELECTVALIDFOLDER = 'Please select a valid [APP] folder';
    public static SELECTVIEW = 'Select View';
    public static SENDANEMAIL = 'Send an e-mail';
    public static SENDAUTOMAIL = 'Auto E-mail';
    public static SENDDOC = 'You are welcome to send the document to support@kalmstrom.com if you feel the document should be supported!';
    public static SENDEMAILCALLER = 'Manual e-mail to Caller';
    public static SENDEMAILFROM = 'Send e-mail from';
    public static SENDEMAILRESPONSIBLE = 'Manual e-mail to Responsible';
    public static SENDER = 'Sender';
    public static SENDERCATEGORY = 'Sender category';
    public static SENDEREMAIL = 'Sender e-mail';
    public static SENDERNAME = 'Sender name';
    public static SENDERPHONE = 'Sender phone';
    public static SENDERS = 'Senders';
    public static SENDHHISLOGREPORT = 'Do you want to send this log report?';
    public static SENDMEEMAIL = 'Please send an e-mail to support@kalmstrom.com and we will help you to solve the issue!';
    public static SENDRECEIVE = 'Sent/Received';
    public static SENDTHISERRORREPORT = 'Do you want to send this error report?';
    public static SENDTOBOOSTLY = 'Would you like to send this error to Boostly Digital?';
    public static SENDTOKALMSTROM = 'Would you like to send this error to kalmstrom.com?';
    public static SENTEMAILS = 'Sent E-mails';
    public static SEP = 'Sep';
    public static SEPARATEHELP = 'Each file becomes its own PDF document.';
    public static SEPARATEPDFS = 'Separate PDFs';
    public static SEPTEMBER = 'September';
    public static SEQUENCE = 'Sequence';
    public static SEQUENCEDESCRIPTION = 'Specify the order of the items in this list';
    public static SERACHINGTICKETS = 'Searching ...';
    public static SERIALKEY = 'Registration key';
    public static SERVER = 'Server';
    public static SERVERFOLDERREPORT = 'The Excel reports have been created.<BR>The reports can be found in the [PRODUCT] server folder';
    public static SERVICEHOURS = 'Service hours';
    public static SESSIONEXPIREDINFO = 'Session expired or problem on SharePoint site. <BR>Please sign in again to continue.';
    public static SET = 'Set';
    public static SETDEFAULTLIST = 'Set Default List';
    public static SETFILTER = 'Set Filter';
    public static SETIMAGE = 'Define image';
    public static SETTING = 'Settings';
    public static SETTINGS = 'Configure';
    public static SETTINGSSAVED = 'Settings saved';
    public static SETTINGSTT = 'Show settings';
    public static SEVENHABHITS = '7 Habits';
    public static SHAREPOINTLISTS = 'SharePoint lists';
    public static SHAREPOINTLOGINFAILED = 'The SharePoint Login information failed!<BR>Please review the user login information under Settings!';
    public static SHAREPOINTSITETOFINDDOCS = 'Choose SharePoint Site to add document libraries from';
    public static SHAREPOINTTICKETSITE = 'SharePoint site';
    public static SHORTCUTPRODUCT = 'Shortcut';
    public static SHORTNOTICEPERIOD = 'Short notice period:';
    public static SHOW = 'Show';
    public static SHOWALL = 'Show all';
    public static SHOWALLSUBTOTALS = 'Show all subtotals';
    public static SHOWCALENDARIMAGES = 'Show calendar images in Overview';
    public static SHOWCAPTION = 'Show captions in HOSP toolbar buttons';
    public static SHOWCORRECTANSWER = 'Show correct answer';
    public static SHOWCORRECTANSWERDESCRIPTION = 'Show the correct answer after three failed attempts.';
    public static SHOWEMAILRECEIVEDTIMEINTICKET = 'Show e-mail received time in the ticket';
    public static SHOWEMAILSAFTERDATE = 'Show e-mails after the date';
    public static SHOWETASKSAFTERDATE = 'Show tasks after the date';
    public static SHOWKANBANVIEW = 'Show Kanban View';
    public static SHOWLARGETASKS = 'Large tasks';
    public static SHOWPRIORITY = 'Show priority';
    public static SHOWSAME = 'Show same';
    public static SHOWSELECTTICKETS = 'Please show tickets and then select tickets to merge';
    public static SHOWSMALLTASKS = 'Small tasks';
    public static SHOWSPASETTING = 'Show SharePoint Attachments Settings';
    public static SHOWSTATISTICS = 'Show statistics';
    public static SHOWTICKETS = 'Show Tickets';
    public static SHOWWEIGHT = 'Show weight';
    public static SHUTDOWN = '<APP> will shut down now';
    public static SIGNATURE = 'Signature';
    public static SIGNOUTMESSAGE = 'Are you sure you want to sign out?';
    public static SITECOLLECTIONADMINIPERMISSIONTOSETUP = 'You need to have Site Collection Administrator permission to set up [PRODUCT].';
    public static SITELOGININFORMATION = 'SharePoint site login information';
    public static SITES = 'Document libraries';
    public static SITEURL = 'Site URL';
    public static SIZE = 'Size';
    public static SMALLSTARTTIME = 'Start time has to be earlier than End time';
    public static SOLUTION = 'Solution';
    public static SORTCOLUMNASC = 'Sort column asc.';
    public static SORTCOLUMNDESC = 'Sort column desc.';
    public static SOUNDONLY = 'Sound only';
    public static SOUTH = 'South';
    public static SPACE = '(Space)';
    public static SPCONNECTION = 'SharePoint Connection';
    public static SPCURRENCYVALIDATION = 'The value of this field must be between [MIN] and [MAX].';
    public static SPDOWN = 'Either there is a problem with internet connectivity, or the SharePoint site is not available at this point.<BR>Please try again later!';
    public static SPECIALCHAR = 'Don^t use a special character (~!@#$%^&*) in the Expense Label.';
    public static SPECIALCHARINGROUPNAME = 'You have used one or more of the following characters: "[CHARACTERS]"<BR>These characters are not allowed in Study Group names. <BR>Please modify the name.';
    public static SPECIFYALISTFORTHISEMAILFOLDER = 'Specify a default list for this folder';
    public static SPECIFYASHAREPOINTLISTFORTHISEMAILFOLDER = 'Specify a default SharePoint list for this folder.';
    public static SPECIFYTHEITEMORDERING = 'Specify the item ordering.';
    public static SPLISTDESC = 'kalmstrom.com [PRODUCT] list for SharePoint';
    public static SPMEMBERCHECK = '[USERNAME] is not a member of this SharePoint site. Please add this person and try again.';
    public static SPUPGRADEDBPERMISSION = 'You do not have permission to update SharePoint lists on this site.<BR>Please get full control or design permission on this site to update the lists.';
    public static SPVALIDENTRY = 'Please enter a valid SharePoint site';
    public static SPVALIDLIBRARYURL = 'Please enter a valid SharePoint library URL.';
    public static SQLAZURESETTINGS = 'SQL Azure Settings';
    public static SQLCREATEDBPERMISSION = 'You do not have permission to create a database on the SQL Server.<BR>Please get ^Sysadmin^ permission and try again.';
    public static SQLISECURITY = 'Integrated Security';
    public static STACKEDBAR = 'Stacked Bar';
    public static STACKEDCOLUMN = 'Stacked Column';
    public static STARTANDENDDATEINFO = 'The start date and time are after the end date and time.';
    public static STARTDATE = 'Start Date';
    public static STARTING = 'Starting';
    public static STARTTIME = 'Start Time';
    public static STATE = 'State';
    public static STATEMINUTESWORKED = 'Please state the number of minutes worked on this incident.';
    public static STATISTICS = 'Statistics';
    public static STATISTICSUPDATEDAT = 'The statistics were updated at:';
    public static STATUS = 'Status';
    public static STOP = 'Stop';
    public static STOPDOUBLES = 'Prevent double-bookings';
    public static STRONGPASSWORDSPECI = 'Strong password specification:';
    public static STUDENT = 'Student';
    public static STUDENTNAME = 'Student Name';
    public static STUDENTNAMEADDEDSUCCESSFULLY = '[NAME] added successfully.';
    public static STUDENTNAMEREMOVEDSUCCESSFULLY = '[NAME] removed successfully.';
    public static STUDENTNAVIGATION = 'Student Navigation';
    public static STUDENTSUMMARIES = 'Student Summaries';
    public static STUDENTSUMMARY = 'Student Summary';
    public static STUDYGROUP = 'Study Group';
    public static STUDYGROUPDDEDSUCCESSFULLY = 'Study Group {0} added successfully.';
    public static STUDYGROUPFORNAME = 'Study Group(s) for [NAME]';
    public static STUDYGROUPNAME = 'Name of Study Group';
    public static STUDYGROUPNAMEALREADYEXISTS = 'Study group ^[NAME]^ already exists';
    public static STUDYGROUPNAMECANNOTBEEMPTY = 'Study Group name cannot be empty. Please enter a study group name.';
    public static STUDYGROUPREMOVEDSUCCESSFULLY = 'Study Group {0} removed successfully.';
    public static SU = 'Su';
    public static SUBFOLDERISSUE = 'Cannot create sub folder ^Converted^. Either you don^t have permission to create subfolders or the folder does not support subfolders.<BR>Do you want to try again?';
    public static SUBJECT = 'Subject';
    public static SUBMIT = 'Submit';
    public static SUBMITTED = 'Submitted';
    public static SUBROUTINE = 'Sub routine';
    public static SUBSCRIPTIONENDDATE = 'Your current subscription expires on';
    public static SUBSCRIPTIONEXPIREDMESSAGE = 'Your current subscription has expired! This feature will not work any longer!';
    public static SUBSCRIPTIONINFOLINK = 'For details about subscription, visit';
    public static SUBSCRIPTIONRENEW = 'Renew your current subscription';
    public static SUBSCRIPTIONREVERTDATE = 'Please revert back to today^s date!';
    public static SUBSCRIPTIONSYNCHRONIZE = 'If the subscription has been paid for, please click ^Synchronize^ to reflect the renewed subscription in the system.';
    public static SUBSCRIPTIONTITLE = 'Subscription Information';
    public static SUBSCRIPTIONUPDATED = 'Your subcription has been updated!';
    public static SUBTASK = 'Subtask';
    public static SUBTOTALS = 'Subtotals';
    public static SUCCESS = 'was successfully installed!';
    public static SUCCESSADDFOLDER = 'The calendar was created';
    public static SUCCESSFULUPGRADEOLD = '[PRODUCT1] has been successfully upgraded to [PRODUCT2]';
    public static SUCCESSREMOVEFOLDER = 'The calendar was removed';
    public static SUCCESSSAVEINFO = 'Calendar info saved';
    public static SUM = 'Sum';
    public static SUMASFRACTIOMOFCOLUMNS = 'Sum as Fraction of Columns';
    public static SUMASFRACTIONOFROWS = 'Sum as Fraction of Rows';
    public static SUMASFRACTIONOFTOTAL = 'Sum as Fraction of Total';
    public static SUMMARIES = 'Summaries';
    public static SUMMARY = 'Summary:';
    public static SUMOFCOMPLETEDTASKS = 'Sum of completed tasks';
    public static SUMOFHOURSOPEN = 'Sum of Hours Open';
    public static SUMOFOVERDUETASKS = 'Sum of overdue tasks';
    public static SUMOFPRICE = 'Sum of price';
    public static SUMOFRATE = 'Sum of Rate';
    public static SUMOVERSUM = 'Sum over Sum';
    public static SUN = 'Sun';
    public static SUNDAY = 'Sunday ';
    public static SUPERCATEGORY = 'Super category';
    public static SUPPLY = 'Supplies';
    public static SUPPLYEMAILINFO = 'Enter the text and formatting you wish to use in the HTML editor to the right and place the tags above where you want them.<BR> In the sent e-mail these tags will be filled with the correct information.';
    public static SUPPLYID = 'Supply ID';
    public static SUPPLYLIST = 'Supplies that can be ordered';
    public static SUPPLYREMOVE = '[SUPPLY] should be removed from existing bookings also.';
    public static SWITCHTASKSLIST = 'Are you sure you want to switch SharePoint Tasks list?';
    public static SWITCHTEMPLATESLIBRARY = 'Switch Templates Library';
    public static SYNC = 'Sync';
    public static SYNCALLTASKS = 'Synchronize All';
    public static SYNCHRONIZE = 'Synchronize';
    public static TABLE = 'Table';
    public static TAGCATEGORY = 'Tag Category';
    public static TAGCOMBINATION = 'This tag value combination already exists.<BR>Please choose another one.';
    public static TAGFIRST = 'Please enter a tag first.';
    public static TAGINGDOC = 'Tagging document with selected tags.';
    public static TAGS = 'Tags';
    public static TAGTYPE = 'Tag Type';
    public static TAGTYPEFIRST = 'Please enter a tag type first. ';
    public static TAGVALUE = '[PRODUCT] tag values';
    public static TASK = 'Task';
    public static TASKCLOSENAG = 'Are you sure you want to close this task?<br>Your changes will not be saved.';
    public static TASKCOLOR = 'Task color';
    public static TASKCOLUMNEXERCISEDESCRIPTION = 'Select what exercise this task should belong to.';
    public static TASKCOLUMNSEQUENCEDESCRIPTION = 'If you have not checked the box for randomized tasks in the Exercise form, specify the order of this task in relation to other tasks.';
    public static TASKCOLUMNTITLEDESCRIPTION = 'Study Manager will add a title automatically. Write a title here if you want your own text. It will not be visible to students.';
    public static TASKCOMPLETED = 'Task completed';
    public static TASKDELETED = 'The corresponding task has been deleted.';
    public static TASKDELETEDBYANOTHERUSER = 'This Item does not exist. it may have been deleted by another user. Please refresh your browser or Click on [PRODUCT] in the Quick Launch.';
    public static TASKID = 'Task ID';
    public static TASKLISTFORKTM = 'Task list for KTM';
    public static TASKLISTS = 'Tasks Lists';
    public static TASKMOVECONFIRMATION = 'Are you sure that you want to move the task ^[SUBJECT]^ to the site ^[SITE]^.';
    public static TASKMOVEDVALIDATION = 'Tasks cannot be created or moved, because the list has been configured with validation.';
    public static TASKMOVEINLANEANDPHASE = 'Lane changed from [LANEFROM] to [LANETO] and Phase changed from [PHASEFROM] to [PHASETO]';
    public static TASKMOVEINLANEORPHASE = '[CHANGE] changed from [FROM] to [TO]';
    public static TASKMOVESUCESS = 'Task moved successfully.';
    public static TASKNAME = 'Task Name';
    public static TASKPERLANEANDPHASE = 'Tasks per Lane and Phase';
    public static TASKPERPHASEANDLANE = 'Tasks per Phase and Lane';
    public static TASKPRIORITY = 'Task priority';
    public static TASKRECYCLED = 'Task moved to the recycle bin';
    public static TASKS = 'Tasks';
    public static TASKSBELOWEXERCISE = 'Tasks below exercise';
    public static TASKSFROM = 'Show Tasks from';
    public static TASKSOVERDUEPERPHASE = 'Overdue Tasks per Phase';
    public static TASKSPERCENTCOMPLETED = '% completed tasks';
    public static TASKSPERCENTPERLANE = 'Average of Tasks % completed per Lane';
    public static TASKSPERCENTPERPHASE = 'Average of Tasks % completed per Phase';
    public static TASKSPERCENTPERRESPONSIBLE = 'Average of Tasks % completed per Assigned';
    public static TASKSPERRESPONSIBLE = 'Tasks per Assigned';
    public static TASKSTATUSPERLANE = 'Status of Tasks per Lane';
    public static TASKSTATUSPERPHASE = 'Status of Tasks per Phase';
    public static TASKTORIGHT = 'Tasks to the right';
    public static TCUSER = 'TimeCard user';
    public static TEMPLATE = 'Template';
    public static TEMPLATECATEGORY = 'Template Category';
    public static TEMPLATECATEGORYALREADYEXIST = 'This template category already exists.';
    public static TEMPLATECATEGORYCANNOTBEEMPTY = 'Template Category cannot be empty. Please enter a template category.';
    public static TEMPLATEFIELDS = 'Template Fields';
    public static TEMPLATES = 'Templates';
    public static TEMPLATESELECTOR = 'Template Selector';
    public static TEMPLATESLIBRARY = 'Templates library';
    public static TEMPLATESTITLE = 'Select a template and click Use to reply to incoming e-mail.';
    public static TEMPORARYERRORFROMAZURE = 'Temporary error from Azure, please try again';
    public static TENTATIVE = 'Tentative';
    public static TEST = 'Test';
    public static TESTDESCRIPTION = 'Let students go on with the exercise even if task answers are wrong. The correct answers will be displayed after the last task.';
    public static TEXT = 'Text';
    public static TEXTALIGN = 'Text align';
    public static TEXTALIGNMENT = 'Text alignment';
    public static TEXTBODY = 'Text body';
    public static TEXTCOLUMNSEQUENCEDESCRIPTION = 'Specify the order of this text in relation to other texts.';
    public static TEXTS = 'Texts';
    public static TH = 'Th';
    public static THANKSFORSENDING = 'Thank you for sending the error, we will get back to you! If you need further assistance please e-mail support@kalmstrom.com';
    public static THANKSFORSENDINGBOSSTLY = 'Thank you for sending the error, we will get back to you! If you need further assistance please e-mail peter@boostly.digital';
    public static THANKYOUFORBUYING = 'Thank you!';
    public static THEDATEOFMONTH = 'The [X] [Y] of [Z]';
    public static THIRD = 'Third';
    public static THOUSANDSEPARATOR = '1000 separator';
    public static THREADLFIEL = 'Threading Field';
    public static THU = 'Thu';
    public static THURSDAY = 'Thursday';
    public static TICKET = 'Ticket';
    public static TICKETCATEGORYNOTSPECIFIED = 'Please set filter to search open, closed or both type of tickets.';
    public static TICKETCLOSED = 'Ticket Closed';
    public static TICKETCREATEDOPENNOW = 'A new ticket has been created.<BR>Do you want to open it now?';
    public static TICKETEMAILHISTORIESINTOBODIES = 'Do you want to save all your e-mail histories into their corresponding ticket bodies?';
    public static TICKETEXPORT = 'Tickets successfully exported to file';
    public static TICKETFORMSETTINGS = 'Ticket Form Settings';
    public static TICKETHASBEENMERGEDDOYOUWANTTOOPENIT = 'The tickets have been merged. Do you want to open the resulting ticket?';
    public static TICKETID = 'Ticket ID';
    public static TICKETIDDATE = 'Ticket # [TICKETID], created at [DATE]';
    public static TICKETIDMANDATORY = 'The [TICKETID] variable has to be included in the ticket subject.';
    public static TICKETOVERDUE = 'This ticket is overdue!';
    public static TICKETSAVEPROGRESS = 'The ticket is being saved. Please try again in a few seconds.';
    public static TICKETSFIXED = 'Tickets corrected';
    public static TICKETSTATUS = 'Ticket status';
    public static TIME = 'Time';
    public static TIMELINEVIEWNAME = 'Timeline';
    public static TIMELOGGING = 'Time Logging';
    public static TIMEMANIPULATION = 'Time manipulation';
    public static TIMEREPORTED = 'Time Reported ';
    public static TIMESPENT = 'Time spent';
    public static TIMESPENTPERLANE = 'Time spent per Lane';
    public static TIMESPENTPERPHASE = 'Time spent per Phase';
    public static TITLE = 'Title';
    public static TITLENOTSPECIFIED = 'Please fill out the FAQ title';
    public static TMCAT1 = 'Brochures';
    public static TMCAT10 = 'Schedules';
    public static TMCAT11 = 'Surveys';
    public static TMCAT2 = 'Budgets';
    public static TMCAT3 = 'Calendar Templates';
    public static TMCAT4 = 'Financial Management';
    public static TMCAT5 = 'Flyers';
    public static TMCAT6 = 'Invoices';
    public static TMCAT7 = 'Letters';
    public static TMCAT8 = 'Papers and Reports';
    public static TMCAT9 = 'Planners and Trackers';
    public static TMEXDESC1 = 'Conduct a brainstorming session and compile everyone^s ideas into this handy idea planner template.';
    public static TMEXDESC10 = 'Weight loss is more fun with two - grab a friend or partner and use this template to track your progress.';
    public static TMEXDESC11 = 'Log your personal expenses with this smartly-designed template.';
    public static TMEXDESC12 = 'Need some stationery? Use this personal letterhead template to add some polish to your communications.';
    public static TMEXDESC13 = 'Tracking your money just got easier with this personal money tracker template!';
    public static TMEXDESC14 = 'Get RSVPs from your guests with this online event survey template.';
    public static TMEXDESC15 = 'Track company income and expenses with this 12-month profit and loss statement template.';
    public static TMEXDESC16 = 'Jump right into your project planning with this pre-formatted template.';
    public static TMEXDESC17 = 'Use this template to divvy up project assignments and track progress.';
    public static TMEXDESC18 = 'It^s easy to create a great looking cover letter with this template.';
    public static TMEXDESC19 = 'Create a reward flyer when someone or something valuable to you is missing and you need to get the word out.';
    public static TMEXDESC2 = 'Set the year and starting weekday, and you^ve got a 12-month calendar template with days and weeks numbered from January 1 through December 31.';
    public static TMEXDESC20 = 'This calendar template is designed around months with major holidays.';
    public static TMEXDESC21 = 'Create a professional invoice for your service business with this template.';
    public static TMEXDESC22 = 'Make a great first impression with this resume cover letter template.';
    public static TMEXDESC23 = 'Attract attention with this flyer template that announces a special event - a sale, grand opening, or other occasion.';
    public static TMEXDESC24 = 'Come spring, use this floral-themed flyer to get the word out about a special event.';
    public static TMEXDESC25 = 'This 12-month, student-focused template has separate tabs for each month and works for any year. Track school assignments and class schedules and due dates.';
    public static TMEXDESC26 = 'Draw crowds with this flyer template that gets the word out about your upcoming event or party.';
    public static TMEXDESC27 = 'Create a great looking report with cover sheet using this term paper template.';
    public static TMEXDESC28 = 'Teachers can use this template to write a reference letter for a student who is applying for a job or college admission.';
    public static TMEXDESC29 = 'You^ll always be on time to class when you manage your school day with this schedule template.';
    public static TMEXDESC3 = 'Organize lesson plans daily with this contemporary template.';
    public static TMEXDESC30 = 'Teachers, let your students know what to expect from your class with this syllabus template.';
    public static TMEXDESC31 = 'Track your tax expenses with this journal template. It keeps a running total as you go.';
    public static TMEXDESC32 = 'Working on a team project? Organize your report with this template that has the formatting all set up for you.';
    public static TMEXDESC33 = 'Customize this template with your own photos and text to create a simple travel brochure.';
    public static TMEXDESC34 = 'Organize your overseas trip with this handy planner template. Make a list of items to pack and arrangements to make, as well as things to do when you get to your destination.';
    public static TMEXDESC35 = 'Track all your course requirements with this assignment sheet template in calendar format. Helps you plan your week.';
    public static TMEXDESC36 = 'Set the schedule for the week for your group^s events or projects with this planning template.';
    public static TMEXDESC37 = 'This all-purpose report template will make your writing look polished and professional.';
    public static TMEXDESC38 = 'What do your employees think of their jobs, the company, and their benefits? Find out with this online survey template.';
    public static TMEXDESC4 = 'Write up your literature analysis with this template that^s already set up for you with a cover page, headings, and formatting for a great looking paper.';
    public static TMEXDESC5 = 'Students, use this starter template to write your research or term paper in MLA format.';
    public static TMEXDESC6 = 'Use this pre-formatted template to write your business letter with ease.';
    public static TMEXDESC7 = 'Tracking your money just got easier with this personal money tracker template.';
    public static TMEXDESC8 = 'Do you have more or less money each month than you expect? Estimate what your monthly income and expenses in this budget template.';
    public static TMEXDESC9 = 'Ever wanted to know how much you^re worth? This easy-to-use template will help you calculate that!';
    public static TMEXNAME1 = 'Idea Planner';
    public static TMEXNAME10 = 'Partner Weight Tracker';
    public static TMEXNAME11 = 'Personal Expenses Calculator';
    public static TMEXNAME12 = 'Personal Letterhead';
    public static TMEXNAME13 = 'Personal Money Tracker';
    public static TMEXNAME14 = 'Planning Survey';
    public static TMEXNAME15 = 'Profit and Loss';
    public static TMEXNAME16 = 'Project Outline';
    public static TMEXNAME17 = 'Project Task List';
    public static TMEXNAME18 = 'Resume Cover Letter';
    public static TMEXNAME19 = 'Reward Flyer';
    public static TMEXNAME2 = 'Julian Calendar';
    public static TMEXNAME20 = 'Seasonal Calendar';
    public static TMEXNAME21 = 'Service Invoice';
    public static TMEXNAME22 = 'Simple Cover Letter';
    public static TMEXNAME23 = 'Small Business Flyer';
    public static TMEXNAME24 = 'Spring Flyer';
    public static TMEXNAME25 = 'Student Calendar';
    public static TMEXNAME26 = 'Student Flyer';
    public static TMEXNAME27 = 'Student Paper';
    public static TMEXNAME28 = 'Student Reference Letter';
    public static TMEXNAME29 = 'Student Schedule';
    public static TMEXNAME3 = 'Lesson Plan';
    public static TMEXNAME30 = 'Syllabus';
    public static TMEXNAME31 = 'Tax Expense Journal';
    public static TMEXNAME32 = 'Team Report';
    public static TMEXNAME33 = 'Travel Brochure';
    public static TMEXNAME34 = 'Trip Planner';
    public static TMEXNAME35 = 'Weekly Assignment Sheet';
    public static TMEXNAME36 = 'Weekly Group Schedule';
    public static TMEXNAME37 = 'White Paper Layout';
    public static TMEXNAME38 = 'Workplace Survey';
    public static TMEXNAME4 = 'Literature Review';
    public static TMEXNAME5 = 'MLA Style Paper';
    public static TMEXNAME6 = 'Modern Letterhead';
    public static TMEXNAME7 = 'Money Tracker';
    public static TMEXNAME8 = 'Monthly Family Budget';
    public static TMEXNAME9 = 'Net Worth Summary';
    public static TO = 'To';
    public static TODAY = 'Today';
    public static TOOFEWARECLICKED = 'Too few are clicked. ';
    public static TOOLBARSETTINGS = 'Ribbon Settings';
    public static TOOLS = 'Tools';
    public static TOOMANYARECLICKED = 'Too many are clicked. ';
    public static TOTALCOST = 'Total Cost';
    public static TOTALEMAILSPECATEGORY = 'Number of E-mails per Category';
    public static TOTALMAILSPEREXTRA = 'Number of E-mails per [EXTRA]';
    public static TOTALMAILSPERLANE = 'Number of E-mails per Lane';
    public static TOTALMAILSPERPHASE = 'Number of E-mails per Phase';
    public static TOTALNUMOFRESOURCES = 'Number of Resources';
    public static TOTALS = 'Totals';
    public static TOTALTASKSPEREXTRA = 'Number of Tasks per [EXTRA]';
    public static TOTALTASKSPERLANE = 'Number of Tasks per Lane';
    public static TOTALTASKSPERPHASE = 'Number of Tasks per Phase';
    public static TOTALTASKSPERPROJECT = 'Number of Tasks per Project';
    public static TOTALTASKSPERRESPONSIBLE = 'Number of Tasks per Responsible';
    public static TOTALTIME = 'Total Time';
    public static TOTALTIMESPENT = 'Total time spent';
    public static TOTALWORKINHR = 'Total Work in Hrs';
    public static TOTALWORKINHRS = 'Total working Hrs.';
    public static TPECOLOR = 'Type Color';
    public static TREEMAP = 'Treemap';
    public static TRIALENDED = 'The evaluation period has expired - this feature will no longer work! Please contact sales@kalmstrom.com if you want to continue using [PRODUCT].';
    public static TRIALPERIODSTARTED = 'Your 30 days trial period has started.';
    public static TRUE = 'True';
    public static TRYAGAIN = 'Do you want to try again?';
    public static TRYAGAINB = 'Try again';
    public static TU = 'Tu';
    public static TUE = 'Tue';
    public static TUESDAY = 'Tuesday';
    public static TYPE = 'Type';
    public static UIRENDERERROR = 'An error occurred rendering the Pivot Table UI.';
    public static UNABLETOCONNECTSHAREPOINT = 'Unable to connect to the SharePoint site %s.';
    public static UNABLETOFINDCUBFILE = 'Unable to find .cub file!';
    public static UNABLETOFINDKB = 'Failed to get KBase Folder!';
    public static UNABLETOSEND = 'The error could not be reported. \nPlease e-mail support@kalmstrom.com and we will do our best to fix this!';
    public static UNABLETOSENDBOOSTLY = 'The error could not be reported. \nPlease e-mail peter@boostly.digital and we will do our best to fix this!';
    public static UNASSIGNED = 'Unassigned';
    public static UNASSIGNEDTASKS = 'Number of Not Assigned tasks';
    public static UNDERLINE = 'Underline';
    public static UNDO = 'Undo';
    public static UNHANDLED = 'Unhandled';
    public static UNINSTALL = 'Uninstall';
    public static UNINSTALLDESC1 = 'This will delete all your templates and " & vbCrLf & " remove " & TOOLBARNAME & " from the folder you select!';
    public static UNINSTALLDESC2 = 'Are you sure you want to do this?';
    public static UNINSTALLFAILURE = 'Failed to uninstall.';
    public static UNINSTALLSUCCESS = 'Uninstall successfully completed!';
    public static UNIQEID = 'Unique identifier for this ticket';
    public static UNIQUEVALUES = 'Unique Values';
    public static UNKNOWN = 'Unknown';
    public static UNREG = 'This is an unlicensed version of';
    public static UNSUBSCRIBED = 'Your subscription to [PRODUCT] has expired. <BR>Please contact sales@kalmstrom.com for assistance.';
    public static UPDATE = 'Update';
    public static UPDATENOW = 'Do you want to update now?';
    public static UPDATETABGRAPH = 'Updating tables and charts';
    public static UPGRADE = 'Upgrade';
    public static UPGRADECOMPLETED = 'Upgrade successfully completed!';
    public static UPGRADENOWSQLAZURE = 'Do you wish to upgrade now? You need to have administrator credentials to upgrade.';
    public static UPGRADEPRODUCTMESSAGE = 'Upgrading [PRODUCT], please wait...';
    public static UPGRADESTATICSCUBEFORAZURE = 'You need to have administrator credentials to create the statistics cube';
    public static UPGRADETASKMESSAGE = 'Upgrading the KTM tasks list, please wait.';
    public static UPLOADPROBLEM = 'There was a problem uploading the attachment to the SharePoint server.';
    public static UPLOADTOSITE = 'Upload to SharePoint list ...';
    public static URGENT = 'Urgent';
    public static URL = 'URL';
    public static URLOFSHAREPOINTSITE = 'Please insert the URL for the SharePoint site';
    public static USE = 'Use';
    public static USECUSTOMFIELDASLANE = 'Use custom field values as lanes';
    public static USEDEFAULTCALENDAR = 'Do you want to use the default calendar? If you answer No, you will get to choose another calendar to use for TimeCard.';
    public static USEHTMLORPLAINTEXT = 'Use html or plain text to describe this report';
    public static USEIEPROXYSETTINGS = 'Use IE proxy settings';
    public static USEKBASEFORCLOSEDTICKET = 'Use KBase for closed tickets';
    public static USER = 'User';
    public static USERCATEGORY = 'User Category';
    public static USEREXISTS = 'This user no longer exists';
    public static USERMANUAL = 'User Manual';
    public static USERNAME = 'Username';
    public static USERNAMECONTAINILLEGALCHARACTERS = 'The User name contains invalid characters, like @,#,$,%,!,~,^,&,* or contains an SQL Azure key word';
    public static USERNOTEXIST = 'You are not a [PRODUCT] student. Please contact your teacher or SharePoint administrator.';
    public static USESYSTEMLANGUAGE = 'Use System Language';
    public static USETITLE = 'Reply to the selected e-mail(s) with this template';
    public static VALIDCURRENCY = 'Please insert a valid currency format.';
    public static VALIDDATE = 'Please select or type a valid date';
    public static VALIDSHAREPOINTSITEURL = 'Please enter a valid SharePoint site URL.';
    public static VALUE = 'Value';
    public static VALUENAME = 'Value name';
    public static VALUESCANNOTBEEMPTY = 'All values must be entered.';
    public static VALUETHATEXCEEDSWHOLEDAY = 'Please do not enter a value that exceeds 24 hrs for all day.';
    public static VERIFIEDBYTEACHER = 'Verified by teacher';
    public static VERIFYINGTABLE = 'Verifying database table';
    public static VERSION = 'Version';
    public static VERSIONS = 'Versions';
    public static VIEW = 'View';
    public static VIEWBY = 'View by:';
    public static VIEWEVENTS = 'View 30 more events';
    public static VIEWNAME = 'View name (min. 3 characters):';
    public static VIEWS = 'Views';
    public static VIEWSOURCE = 'View Source';
    public static VIEWSTATISTICS = 'View Statistics';
    public static VISIBLE = 'Visible';
    public static VS = 'vs';
    public static WAITASSIGNINGROLE = 'Assigning role to user, please wait...';
    public static WAITCHECKINGTMPUBLISHERSITE = 'Validating the [PRODUCT] Publisher site, please wait..';
    public static WAITCHEKINGPASSWORD = 'Checking password, please wait...';
    public static WAITCREATINGSP = 'Creating Stored Procedures in database [DATABASENAME], please wait...';
    public static WAITCREATINGTABLES = 'Creating tables in database [DATABASENAME], please wait...';
    public static WAITCREATINGTICKET = 'Creating ticket, please wait...';
    public static WAITCREATINGUSER = 'Creating user, please wait...';
    public static WAITCREATINGUSERROLE = 'Creating user role, please wait...';
    public static WAITFORMAIL = 'Within 24 hours after payment you will get an e-mail with the registration code from support@kalmstrom.com.';
    public static WAITINGONSOMEONEELSE = 'Waiting on someone else';
    public static WAITMAKINGCONNECTION = 'Making connection, please wait...';
    public static WAITVALIDATING = 'Validating, please wait...';
    public static WATERMARK = 'Watermark:';
    public static WATERMARKEXAMPLE = 'e.g. DRAFT';
    public static WATERMARKHELP = 'Text overlay on every page (e.g. DRAFT, CONFIDENTIAL).';
    public static WATERMARKOPTIONAL = 'Watermark (optional):';
    public static WATERMARKPLACEHOLDER = 'Leave empty for no watermark';
    public static WE = 'We';
    public static WEBFOLDERPERMISSION = 'The permissions on the helpdesk web folder is not set with appropriate levels. Please consult your administrator!';
    public static WEBINFO = 'To report an incident, please fill out the following form and click Submit';
    public static WEBREPORTISSUE = 'Report a new issue';
    public static WEBSTOREBUY = 'Purchase through our eSellerate web store (manual registration).';
    public static WEBTHANKYOU1 = 'Thank you for reporting this issue.';
    public static WEBTHANKYOU2 = 'It will now be transferred to our helpdesk staff, and one of them will soon contact you.';
    public static WED = 'Wed';
    public static WEDNESDAY = 'Wednesday';
    public static WEEK = 'Week';
    public static WEEKDAY = 'Weekday';
    public static WEEKDEF = 'This week is default.';
    public static WEEKENDDAY = 'Weekend day';
    public static WEEKLY = 'Weekly';
    public static WEEKLYRECURRENCE = 'Recur every [X] week(s) on:';
    public static WEEKORMONTH = 'Week/Month';
    public static WEIGHT = 'Weight';
    public static WELCOME = 'Welcome';
    public static WHENBOOKING = 'When booking';
    public static WHICHDEPARTMENT = 'Please state which department you belong to';
    public static WIDTH = 'Width';
    public static WILLBEADDEDTOMEMBERS = 'This user will be added to the default members group of this site';
    public static WILLFUNCTION = 'This version will function';
    public static WIP = 'Work in progress';
    public static WORD = 'Word';
    public static WORDDOCUMENT = 'Word Document';
    public static WORK = 'Work';
    public static WORKDESCRIPTIONS = 'Work Descriptions';
    public static WORKDONE = 'Work Done';
    public static WORKING1 = 'Working with ';
    public static WORKINGKBCATEGORYANDTYPE = 'Working with KBase categories and types';
    public static WORKINGONEXCEL = 'Working on Excel, please wait...';
    public static WORKINGONIT = 'Working on it...';
    public static WORKWEEK = 'Workweek';
    public static WORKWITHDOCUMENT = 'Work with document';
    public static WRITECORRECTANSFIRST = 'Please write the correct answer first. ';
    public static WRITEDOCEXNOTSUPPORTEDSPBELOW2013 = 'The "Write document" exercise type is not supported for SharePoint versions below 2013.';
    public static WRITELOOKUPTAGS = 'Write lookup tags';
    public static WRITENOW = 'Write now';
    public static WRITEPERMISSIONONLIBRARY = 'You don^t seem to have write permission over the SharePoint library [LIBRARY_NAME].<BR>Please review your permission and try again.';
    public static WRITEPHRASE = 'Write phrase';
    public static WRITESOCIALTAGS = 'Write social tags';
    public static WRITESUBJECT = 'Write tag values in the subject';
    public static WRONGALTERNATIVES = 'Wrong alternatives';
    public static WRONGALTERNATIVESDESCRIPTION = 'Enter one wrong alternative on each row.';
    public static WRONGANSTRYAGAIN = 'Your answer is wrong. Please try again.';
    public static WRONGFOLDERTYPE = 'Wrong folder-type!';
    public static WRONGPASSWORD = 'Wrong password. Please try again.';
    public static WRONGSUBJECT = 'Please use only [TICKETID] for subject. Do not add { } in the subject.';
    public static WYSIWYG = 'WYSIWYG';
    public static YEAR = 'Year';
    public static YEARDEF = 'This year is default.';
    public static YEARLY = 'Yearly';
    public static YEARS = 'Years';
    public static YEARVIEW = 'Year View';
    public static YES = 'Yes';
    public static YOUCANNOTDELETEENTRIES = 'You cannot delete [APP]. Articles are associated with it.';
    public static YOUCANNOTDELETEEXTRAVALUE = 'You cannot delete [EXTRA]. Tasks are associated with it.';
    public static YOUCANNOTDELETELANE = 'You cannot delete [LANE]. Tasks are associated with it.';
    public static YOUCANNOTDELETEPHASE = 'You cannot delete [PHASE]. Tasks are associated with it.';
    public static YOUCANNOTDELETEPROJECT = 'You cannot delete [PROJECT]. Tasks are associated with it.';
    public static YOUCANNOTDELETERESPONSIBLE = 'You cannot delete [RESPONSIBLE]. Tasks are associated with this Responsible.';
    public static YOUDONOTHAVEPERMISSIONTOCREATELIST = 'You do not have permission to create or update a list on this site.<BR>Please get full control or design permission on this site to create the list.';
    public static ZOOM = 'Zoom';
}
